[
  {
    "id": 4686,
    "uuid": "990f0608-c757-4ebb-b508-f9f99c4fa5ec",
    "hitokoto": "两种风流，一家制作。雪花全似梅花萼。细看不是雪无香，天风吹得香零落。虽是一般，惟高一着。雪花不似梅花薄。梅花散彩向空山，雪花随意穿帘幕。",
    "type": "i",
    "from": "踏莎行·雪中看梅花",
    "from_who": "王旭",
    "creator": "阑珊",
    "creator_uid": 3002,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579758428",
    "length": 68
  },
  {
    "id": 4688,
    "uuid": "7e0a0206-ec71-4832-b805-9aa2a2cf8b10",
    "hitokoto": "两情若是久长时，又岂在朝朝暮暮？",
    "type": "i",
    "from": "鹊桥仙·纤云弄巧",
    "from_who": "秦观",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1569327478",
    "length": 16
  },
  {
    "id": 4689,
    "uuid": "739ed604-6182-4c36-afb9-39f08128c733",
    "hitokoto": "嗟叹红颜泪、英雄殁，人世苦多。山河永寂、怎堪欢颜。",
    "type": "i",
    "from": "南唐旧梦：山河永寂",
    "from_who": "一寒呵",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1569327779",
    "length": 25
  },
  {
    "id": 4690,
    "uuid": "a53cb819-77fe-4346-a188-59f9c0684eb9",
    "hitokoto": "茅檐低小，溪上青青草。醉里吴音相媚好，白发谁家翁媪？",
    "type": "i",
    "from": "清平乐·村居",
    "from_who": "辛弃疾",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1569327991",
    "length": 26
  },
  {
    "id": 4699,
    "uuid": "9650304e-e843-49e2-a50f-f4b669f15857",
    "hitokoto": "瞿塘嘈嘈十二滩，此中道路古来难。长恨人心不如水，等闲平地起波澜。\r\n",
    "type": "i",
    "from": "竹枝其七",
    "from_who": "刘禹锡",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1569328193",
    "length": 34
  },
  {
    "id": 4895,
    "uuid": "f60e114e-03dd-4c29-8e37-55a2d516d2f3",
    "hitokoto": "醉后不知天在水，满船清梦压星河。",
    "type": "i",
    "from": "题龙阳县青草湖",
    "from_who": "唐温如",
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571142485",
    "length": 16
  },
  {
    "id": 4896,
    "uuid": "2095b5d9-30d6-4cbd-8390-47cbf678ca98",
    "hitokoto": "金风玉露一相逢，便胜却、人间无数。",
    "type": "i",
    "from": "鹊桥仙·纤云弄巧",
    "from_who": "秦观",
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571142617",
    "length": 17
  },
  {
    "id": 4908,
    "uuid": "ee9365a6-5617-414b-8f20-c6fab21ab555",
    "hitokoto": "人生得意须尽欢，莫让金樽空对月。",
    "type": "i",
    "from": "将进酒",
    "from_who": "李白",
    "creator": "夕之树",
    "creator_uid": 4248,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573330996",
    "length": 16
  },
  {
    "id": 4909,
    "uuid": "3886b445-1877-4faf-8834-bb4907b3964a",
    "hitokoto": "莫听穿林打叶声，何妨吟啸且徐行。竹杖芒鞋轻胜马，谁怕？一蓑烟雨任平生。",
    "type": "i",
    "from": "定风波·莫听穿林打叶声",
    "from_who": "苏轼",
    "creator": "夕之树",
    "creator_uid": 4248,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573333565",
    "length": 35
  },
  {
    "id": 4912,
    "uuid": "f45778c6-ce7c-488c-8fa4-f03aeb0f7ee3",
    "hitokoto": "我曾踏月而来，只因你在山中。",
    "type": "i",
    "from": "山月",
    "from_who": "席慕蓉",
    "creator": "清河",
    "creator_uid": 4241,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573285848",
    "length": 14
  },
  {
    "id": 4913,
    "uuid": "0c571b7f-3d56-4384-8e9d-99f77eec4162",
    "hitokoto": "上古有大椿者，以八千岁为春，八千岁为秋。",
    "type": "i",
    "from": "逍遥游",
    "from_who": "庄子",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572959776",
    "length": 20
  },
  {
    "id": 4916,
    "uuid": "c2234304-ef66-4c04-b971-fae53ac9340d",
    "hitokoto": "直道相思了无益，未妨惆怅是清狂。",
    "type": "i",
    "from": "无题",
    "from_who": "李商隐",
    "creator": "kkkek",
    "creator_uid": 4193,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572774355",
    "length": 16
  },
  {
    "id": 4917,
    "uuid": "d35e8a70-ac62-48dd-8918-6d1191e1480a",
    "hitokoto": "南风知我意，吹梦到西洲。",
    "type": "i",
    "from": "西洲曲",
    "from_who": "南朝乐府民歌",
    "creator": "Jessica。",
    "creator_uid": 4191,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572677234",
    "length": 12
  },
  {
    "id": 4922,
    "uuid": "7a58eb6d-1352-4f88-b7ba-5899db4563ef",
    "hitokoto": "报君黄金台上意，提携玉龙为君死。",
    "type": "i",
    "from": "雁门太守行",
    "from_who": "李贺",
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571235827",
    "length": 16
  },
  {
    "id": 4923,
    "uuid": "8e15eb2b-131b-4fb4-bbee-2ad69ee20ac5",
    "hitokoto": "雁字回时，月满西楼，花自飘零水自流。一种相思，两处闲愁。此情无计可消除，才下眉头，却上心头。",
    "type": "i",
    "from": "一剪梅·红藕香残玉簟秋",
    "from_who": "李清照",
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571229593",
    "length": 46
  },
  {
    "id": 4959,
    "uuid": "c9726d2f-204f-440d-98f9-53fad30e61fc",
    "hitokoto": "东隅已逝，桑榆非晚。",
    "type": "i",
    "from": "文学",
    "from_who": "王勃",
    "creator": "小轩",
    "creator_uid": 4925,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581698884",
    "length": 10
  },
  {
    "id": 4960,
    "uuid": "583d8364-01b4-4c75-b052-37c42b61810a",
    "hitokoto": "三尺书生，一介微命。",
    "type": "i",
    "from": "滕王阁序",
    "from_who": "王勃",
    "creator": "小轩",
    "creator_uid": 4925,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581698862",
    "length": 10
  },
  {
    "id": 4982,
    "uuid": "b790ca90-56e8-471e-b040-cb48c6043fc6",
    "hitokoto": "醉后不知天在水，满船清梦压星河。",
    "type": "i",
    "from": "题龙阳县青草湖",
    "from_who": "唐温如",
    "creator": "梵川",
    "creator_uid": 4860,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496953",
    "length": 16
  },
  {
    "id": 4986,
    "uuid": "52af4233-c5f4-4648-b709-cdb9b958da4e",
    "hitokoto": "风花之潇洒，雪月之空清，唯静者为之主；水木之荣枯，竹石之消长，独闲者操其权。",
    "type": "i",
    "from": "菜根谭",
    "from_who": "洪应明",
    "creator": "悠远的苍穹",
    "creator_uid": 4871,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496351",
    "length": 38
  },
  {
    "id": 5098,
    "uuid": "f8914378-5ac7-4d01-8b73-fa2aa6773430",
    "hitokoto": "糜鹿成群，虎豹避之；飞鸟成列，鹰鹫不击。",
    "type": "i",
    "from": "说苑",
    "from_who": "刘向",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582570361",
    "length": 20
  },
  {
    "id": 5112,
    "uuid": "d39dbbff-947b-4051-9a0c-44cd6ad3da26",
    "hitokoto": "醉后不知天在水，满船清梦压星河。",
    "type": "i",
    "from": "题龙阳县青草湖",
    "from_who": "唐温如",
    "creator": "foreversama",
    "creator_uid": 3576,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582705579",
    "length": 16
  },
  {
    "id": 5117,
    "uuid": "c9739bcc-2d6e-482b-bc6e-ac158e2524b1",
    "hitokoto": "为众人抱薪者，不可使其冻毙于风雪。",
    "type": "i",
    "from": "微博",
    "from_who": "慕容雪村",
    "creator": "小黑猫",
    "creator_uid": 4856,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581333219",
    "length": 17
  },
  {
    "id": 5119,
    "uuid": "0e4eb08f-7f86-4155-b2ae-84dca1d1b73b",
    "hitokoto": "桃李春风一杯酒，江湖夜雨十年灯。",
    "type": "i",
    "from": "寄黄几复",
    "from_who": "黄庭坚",
    "creator": "阑珊",
    "creator_uid": 3002,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579758353",
    "length": 16
  },
  {
    "id": 5123,
    "uuid": "9e11dd9d-dd1b-4b97-bffe-05e7255632aa",
    "hitokoto": "且将新火试新茶，诗酒趁年华",
    "type": "i",
    "from": "望江南·超然台作",
    "from_who": "苏轼",
    "creator": "serenityooooo_SS",
    "creator_uid": 4656,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579017912",
    "length": 13
  },
  {
    "id": 5137,
    "uuid": "9ae0a8af-b362-4812-80d6-33fbbee3e70b",
    "hitokoto": "髣髴兮若轻云之蔽月，飘飖兮若流风之回雪。",
    "type": "i",
    "from": "洛神赋",
    "from_who": "曹植",
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575595704",
    "length": 20
  },
  {
    "id": 5138,
    "uuid": "01f5282e-72c3-4eda-8a35-b7055958715c",
    "hitokoto": "恨人神之道殊兮，怨盛年之莫当。",
    "type": "i",
    "from": "洛神赋",
    "from_who": "曹植",
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575595764",
    "length": 15
  },
  {
    "id": 5191,
    "uuid": "628a8db2-fa7b-4684-831e-f24ac06903f0",
    "hitokoto": "高山仰止，景行行止。",
    "type": "i",
    "from": "诗经",
    "from_who": null,
    "creator": "臻子",
    "creator_uid": 5190,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583203478",
    "length": 10
  },
  {
    "id": 5206,
    "uuid": "af700d9a-7740-4afb-bdf0-4ec1681b9b1f",
    "hitokoto": "忽来夜雨未绸缪，挑灯孤影欲还休。",
    "type": "i",
    "from": "原创",
    "from_who": null,
    "creator": "夏遇星",
    "creator_uid": 5224,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583310900",
    "length": 16
  },
  {
    "id": 5232,
    "uuid": "2c29a409-865e-4a07-bff2-92e6496bb3ef",
    "hitokoto": "但屈指西风几时来，又不道流年暗中偷换。",
    "type": "i",
    "from": "洞仙歌·冰肌玉骨",
    "from_who": null,
    "creator": "臻子",
    "creator_uid": 5190,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583589160",
    "length": 19
  },
  {
    "id": 5241,
    "uuid": "4c0517d8-0b30-4e31-a4a9-e6ede666eb82",
    "hitokoto": "抛得开手里玩具，先懂得好好进睡。",
    "type": "i",
    "from": "给自己的情书",
    "from_who": null,
    "creator": "忍冬",
    "creator_uid": 5327,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583824796",
    "length": 16
  },
  {
    "id": 5356,
    "uuid": "f4f448b2-d3d0-4186-950d-52fa8800808a",
    "hitokoto": "海内存知己，天涯若比邻。",
    "type": "i",
    "from": "杜少府之任蜀州",
    "from_who": "王勃",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585384793",
    "length": 12
  },
  {
    "id": 5370,
    "uuid": "1a2f4f01-28a4-4f93-84fa-789049c9759d",
    "hitokoto": "锦官红妆否？不见故人裙。",
    "type": "i",
    "from": "无题",
    "from_who": "佚名",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585446898",
    "length": 12
  },
  {
    "id": 5389,
    "uuid": "479e82b1-311c-43d3-bf4f-3cb23b69b39a",
    "hitokoto": "人皆荒醉，但唱观音。",
    "type": "i",
    "from": "唐大和上东征传",
    "from_who": "淡海三",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585291403",
    "length": 10
  },
  {
    "id": 5396,
    "uuid": "d721f9bb-2232-4a0b-8398-40619bd20b68",
    "hitokoto": "今夜不知何处宿，平沙万里绝人烟。",
    "type": "i",
    "from": "碛中作",
    "from_who": "岑参",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585384889",
    "length": 16
  },
  {
    "id": 5406,
    "uuid": "40514bed-709d-4a9f-910a-ea5b1dad80e8",
    "hitokoto": "人生若只如初见，何事秋风悲画扇。",
    "type": "i",
    "from": "木兰花·拟古决绝词柬友",
    "from_who": "纳兰性德",
    "creator": "hkaren",
    "creator_uid": 5713,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585646961",
    "length": 16
  },
  {
    "id": 5441,
    "uuid": "b8633c21-7d09-449a-a277-ea47e63a7a4f",
    "hitokoto": "山有木兮木有枝，心悦君兮君不知。",
    "type": "i",
    "from": "越人歌",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198946",
    "length": 16
  },
  {
    "id": 5442,
    "uuid": "2acf4ba0-f6b0-4e52-8d8b-9ae7cc3c858f",
    "hitokoto": "人生若只如初见，何事秋风悲画扇。",
    "type": "i",
    "from": "木兰词·拟古决绝词柬友",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198946",
    "length": 16
  },
  {
    "id": 5443,
    "uuid": "d200b686-d03c-4118-9c45-41efcfac57c9",
    "hitokoto": "曾经沧海难为水，除却巫山不是云。",
    "type": "i",
    "from": "离思五首·其四",
    "from_who": "元稹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198946",
    "length": 16
  },
  {
    "id": 5444,
    "uuid": "cf8f4485-5123-4344-b20d-ecc9537c2e16",
    "hitokoto": "人生如逆旅，我亦是行人。",
    "type": "i",
    "from": "临江仙·送钱穆父",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198947",
    "length": 12
  },
  {
    "id": 5445,
    "uuid": "8cd5bf9e-cb4d-4083-96aa-b284878011f2",
    "hitokoto": "十年生死两茫茫，不思量，自难忘。",
    "type": "i",
    "from": "江城子·乙卯正月二十日夜记梦",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198947",
    "length": 16
  },
  {
    "id": 5446,
    "uuid": "7d413a88-9555-4c3c-bf3f-fbacff7116e5",
    "hitokoto": "玲珑骰子安红豆，入骨相思知不知。",
    "type": "i",
    "from": "南歌子词二首 / 新添声杨柳枝词",
    "from_who": "温庭筠",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198948",
    "length": 16
  },
  {
    "id": 5447,
    "uuid": "8453df5d-6e08-4ba8-a139-1bc324d44a7c",
    "hitokoto": "只愿君心似我心，定不负相思意。",
    "type": "i",
    "from": "卜算子·我住长江头",
    "from_who": "李之仪",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198948",
    "length": 15
  },
  {
    "id": 5448,
    "uuid": "d09096b2-1a6d-4721-abeb-13b4018cee70",
    "hitokoto": "入我相思门，知我相思苦。",
    "type": "i",
    "from": "三五七言 / 秋风词",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198948",
    "length": 12
  },
  {
    "id": 5449,
    "uuid": "379c8520-6fce-4158-931e-3e90241e0e2e",
    "hitokoto": "雨打梨花深闭门，误了青春，忘了青春。",
    "type": "i",
    "from": "一剪梅·雨打梨花深闭门",
    "from_who": "唐寅",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198949",
    "length": 18
  },
  {
    "id": 5450,
    "uuid": "78bc8aa9-b81b-4f78-a074-3cfe74cf5983",
    "hitokoto": "平生不会相思，才会相思，便害相思。",
    "type": "i",
    "from": "折桂令·春情",
    "from_who": "徐再思",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198949",
    "length": 17
  },
  {
    "id": 5451,
    "uuid": "9508291d-a9e7-4b76-b225-5e62a82f6acf",
    "hitokoto": "山无陵，江水为竭。冬雷震震，夏雨雪。天地合，乃敢与君绝。",
    "type": "i",
    "from": "上邪",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198950",
    "length": 28
  },
  {
    "id": 5452,
    "uuid": "c453b2dc-8200-4d66-a405-d23dc7451826",
    "hitokoto": "两情若是久长时，又岂在朝朝暮暮。",
    "type": "i",
    "from": "鹊桥仙·纤云弄巧",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198950",
    "length": 16
  },
  {
    "id": 5453,
    "uuid": "1d300772-4c0e-4ec8-a347-2fac0583071e",
    "hitokoto": "愿得一心人，白头不相离。",
    "type": "i",
    "from": "白头吟",
    "from_who": "卓文君",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198950",
    "length": 12
  },
  {
    "id": 5454,
    "uuid": "ea85fc45-3883-42d5-ab6a-b232f83b241a",
    "hitokoto": "去年今日此门中，人面桃花相映红。",
    "type": "i",
    "from": "题都城南庄",
    "from_who": "崔护",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198951",
    "length": 16
  },
  {
    "id": 5455,
    "uuid": "643355d9-03fc-4bc2-b1e5-604fcb8e832f",
    "hitokoto": "春宵一刻值千金，花有清香月有阴。",
    "type": "i",
    "from": "春宵·春宵一刻值千金",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198952",
    "length": 16
  },
  {
    "id": 5456,
    "uuid": "e5910444-76d4-4401-8013-8bdfab428954",
    "hitokoto": "醉后不知天在水，满船清梦压星河。",
    "type": "i",
    "from": "题龙阳县青草湖",
    "from_who": "唐温如",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198953",
    "length": 16
  },
  {
    "id": 5457,
    "uuid": "1df218b3-1d4b-4eb7-a336-b79aa335ea25",
    "hitokoto": "春风得意马蹄疾，一日看尽长安花。",
    "type": "i",
    "from": "登科后",
    "from_who": "孟郊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586198955",
    "length": 16
  },
  {
    "id": 5460,
    "uuid": "59c9a592-9385-458c-8c76-cf6db1635ea3",
    "hitokoto": "人生自是有情痴，此恨不关风与月。",
    "type": "i",
    "from": "玉楼春·尊前拟把归期说",
    "from_who": "欧阳修",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198951",
    "length": 16
  },
  {
    "id": 5461,
    "uuid": "8f1b99a6-ed53-4553-aaca-c9e359a7b93a",
    "hitokoto": "花自飘零水自流。一种相思，两处闲愁。",
    "type": "i",
    "from": "一剪梅·红藕香残玉簟秋",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198951",
    "length": 18
  },
  {
    "id": 5462,
    "uuid": "2408c153-ac1e-4146-b68a-8111ab89975a",
    "hitokoto": "少年不识愁滋味，爱上层楼。爱上层楼，为赋新词强说愁。",
    "type": "i",
    "from": "丑奴儿·书博山道中壁",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198952",
    "length": 26
  },
  {
    "id": 5463,
    "uuid": "4c0984e1-1b5c-4bc6-926c-de4da020512e",
    "hitokoto": "一日不见兮，思之如狂。",
    "type": "i",
    "from": "凤求凰 / 琴歌",
    "from_who": "司马相如",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198953",
    "length": 11
  },
  {
    "id": 5464,
    "uuid": "2ecb0fa8-d92d-466f-9331-6668dfd924ee",
    "hitokoto": "身无彩凤双飞翼，心有灵犀一点通。",
    "type": "i",
    "from": "无题·昨夜星辰昨夜风",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198953",
    "length": 16
  },
  {
    "id": 5465,
    "uuid": "fe37ea2d-2cb9-4b6c-b1e6-3ec944799a7a",
    "hitokoto": "世间无限丹青手，一片伤心画不成。",
    "type": "i",
    "from": "金陵晚望",
    "from_who": "高蟾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198954",
    "length": 16
  },
  {
    "id": 5466,
    "uuid": "c416789d-2ddc-44d4-822d-934e64fc1561",
    "hitokoto": "云想衣裳花想容，春风拂槛露华浓。",
    "type": "i",
    "from": "清平调·其一",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198954",
    "length": 16
  },
  {
    "id": 5467,
    "uuid": "4192a533-a3cc-4a70-af9b-acceaa34c6f3",
    "hitokoto": "问世间，情为何物，直教生死相许？",
    "type": "i",
    "from": "摸鱼儿·雁丘词 / 迈陂塘",
    "from_who": "元好问",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198954",
    "length": 16
  },
  {
    "id": 5468,
    "uuid": "b26851c2-9f38-452b-bfad-5f2a1f06b212",
    "hitokoto": "一声梧叶一声秋，一点芭蕉一点愁，三更归梦三更后。",
    "type": "i",
    "from": "水仙子·夜雨",
    "from_who": "徐再思",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198955",
    "length": 24
  },
  {
    "id": 5469,
    "uuid": "f89fcf54-197f-4c77-9abb-5985d433746b",
    "hitokoto": "滚滚长江东逝水，浪花淘尽英雄。",
    "type": "i",
    "from": "临江仙·滚滚长江东逝水",
    "from_who": "杨慎",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198956",
    "length": 15
  },
  {
    "id": 5470,
    "uuid": "6442d6b4-0e24-483b-ac3f-6dd82ea4b707",
    "hitokoto": "林花谢了春红，太匆匆。无奈朝来寒雨，晚来风。",
    "type": "i",
    "from": "相见欢·林花谢了春红",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198956",
    "length": 22
  },
  {
    "id": 5471,
    "uuid": "1182b6d9-ea87-4957-a820-d25520be8107",
    "hitokoto": "君埋泉下泥销骨，我寄人间雪满头。",
    "type": "i",
    "from": "梦微之",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198956",
    "length": 16
  },
  {
    "id": 5472,
    "uuid": "ba76ae0f-599b-48b1-8990-8a18a400206d",
    "hitokoto": "休对故人思故国，且将新火试新茶。诗酒趁年华。",
    "type": "i",
    "from": "望江南·超然台作",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198957",
    "length": 22
  },
  {
    "id": 5473,
    "uuid": "1e743799-cd11-49b6-8412-d76813d05efe",
    "hitokoto": "一往情深深几许？深山夕照深秋雨。",
    "type": "i",
    "from": "蝶恋花·出塞",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198957",
    "length": 16
  },
  {
    "id": 5474,
    "uuid": "e8d4b74c-e6fd-49dd-ac5f-c109e6c04929",
    "hitokoto": "执子之手，与子偕老。",
    "type": "i",
    "from": "击鼓",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198957",
    "length": 10
  },
  {
    "id": 5475,
    "uuid": "05013dc7-279e-430b-94db-018b1457d49b",
    "hitokoto": "自在飞花轻似梦，无边丝雨细如愁。",
    "type": "i",
    "from": "浣溪沙·漠漠轻寒上小楼",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198958",
    "length": 16
  },
  {
    "id": 5476,
    "uuid": "ae3516b7-d0d0-474a-96f9-b02a5a057c53",
    "hitokoto": "菩提本无树，明镜亦非台。",
    "type": "i",
    "from": "菩提偈",
    "from_who": "惠能",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198958",
    "length": 12
  },
  {
    "id": 5477,
    "uuid": "5c765950-832a-4de3-a6fe-c4f3459fcfa1",
    "hitokoto": "一生大笑能几回，斗酒相逢须醉倒。",
    "type": "i",
    "from": "凉州馆中与诸判官夜集",
    "from_who": "岑参",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198958",
    "length": 16
  },
  {
    "id": 5478,
    "uuid": "91b58cea-2c30-4ab3-8842-bcb9650f5871",
    "hitokoto": "此情可待成追忆，只是当时已惘然。",
    "type": "i",
    "from": "锦瑟",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198959",
    "length": 16
  },
  {
    "id": 5479,
    "uuid": "8bd297bb-caee-4f2e-84c0-a59a20d07bbb",
    "hitokoto": "人面不知何处去，桃花依旧笑春风。",
    "type": "i",
    "from": "题都城南庄",
    "from_who": "崔护",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198959",
    "length": 16
  },
  {
    "id": 5480,
    "uuid": "97dd7450-147e-4b25-97b6-2e56dc9aa321",
    "hitokoto": "抽刀断水水更流，举杯消愁愁更愁。",
    "type": "i",
    "from": "宣州谢脁楼饯别校书叔云 / 陪侍御叔华登楼歌",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198960",
    "length": 16
  },
  {
    "id": 5481,
    "uuid": "689d42cb-466e-4d5c-9288-24435040c646",
    "hitokoto": "昨夜西风凋碧树，独上高楼，望尽天涯路。",
    "type": "i",
    "from": "蝶恋花·槛菊愁烟兰泣露",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198960",
    "length": 19
  },
  {
    "id": 5482,
    "uuid": "421766d9-31a0-46c6-a049-55b9069bb55e",
    "hitokoto": "疏影横斜水清浅，暗香浮动月黄昏。",
    "type": "i",
    "from": "山园小梅·其一",
    "from_who": "林逋",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198960",
    "length": 16
  },
  {
    "id": 5483,
    "uuid": "85d5a346-c31f-421e-a618-e537c22b6683",
    "hitokoto": "仰天大笑出门去，我辈岂是蓬蒿人。",
    "type": "i",
    "from": "南陵别儿童入京",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198961",
    "length": 16
  },
  {
    "id": 5484,
    "uuid": "4216eade-9414-4b1c-8867-a16e24e8dd96",
    "hitokoto": "思悠悠，恨悠悠，恨到归时方始休。",
    "type": "i",
    "from": "长相思·汴水流",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198961",
    "length": 16
  },
  {
    "id": 5485,
    "uuid": "dcf708cf-8679-4d11-b4ed-371004d2f94e",
    "hitokoto": "似此星辰非昨夜，为谁风露立中宵。",
    "type": "i",
    "from": "绮怀",
    "from_who": "黄景仁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198961",
    "length": 16
  },
  {
    "id": 5486,
    "uuid": "94314e49-cff2-49b2-98bb-cee3fdff0063",
    "hitokoto": "行到水穷处，坐看云起时。",
    "type": "i",
    "from": "终南别业 / 初至山中 / 入山寄城中故人",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198962",
    "length": 12
  },
  {
    "id": 5487,
    "uuid": "b2f4952e-e451-4360-8f2d-255e67405d14",
    "hitokoto": "近水楼台先得月，向阳花木易为春。",
    "type": "i",
    "from": "断句",
    "from_who": "苏麟",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198962",
    "length": 16
  },
  {
    "id": 5488,
    "uuid": "cc0b8e6d-3650-45be-a770-a487d985597d",
    "hitokoto": "浮云一别后，流水十年间。",
    "type": "i",
    "from": "淮上喜会梁川故人 / 淮上喜会梁州故人",
    "from_who": "韦应物",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198963",
    "length": 12
  },
  {
    "id": 5489,
    "uuid": "9acbecc2-7234-4d4b-9c0c-73951e33ddb9",
    "hitokoto": "桃李春风一杯酒，江湖夜雨十年灯。",
    "type": "i",
    "from": "寄黄几复",
    "from_who": "黄庭坚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198963",
    "length": 16
  },
  {
    "id": 5490,
    "uuid": "0bc177fb-d8d7-483d-a964-513ff38bf904",
    "hitokoto": "沾衣欲湿杏花雨，吹面不寒杨柳风。",
    "type": "i",
    "from": "绝句",
    "from_who": "志南",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198964",
    "length": 16
  },
  {
    "id": 5491,
    "uuid": "f1ba56b0-6883-401c-8682-1068120d6182",
    "hitokoto": "若是前生未有缘，待重结、来生愿。",
    "type": "i",
    "from": "卜算子·答施",
    "from_who": "乐婉",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198964",
    "length": 16
  },
  {
    "id": 5492,
    "uuid": "f2de9bde-9692-4434-a0a5-f81f78b6dfdd",
    "hitokoto": "时光只解催人老，不信多情，长恨离亭，泪滴春衫酒易醒。",
    "type": "i",
    "from": "采桑子·时光只解催人老",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586198964",
    "length": 26
  },
  {
    "id": 5495,
    "uuid": "f69cfc46-84dd-4935-abe8-bc10fece3e96",
    "hitokoto": "取次花丛懒回顾，半缘修道半缘君。",
    "type": "i",
    "from": "离思五首·其四",
    "from_who": "元稹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586265725",
    "length": 16
  },
  {
    "id": 5496,
    "uuid": "4e1cce58-01a3-48bb-aee1-89e693d40498",
    "hitokoto": "溪云初起日沉阁，山雨欲来风满楼。",
    "type": "i",
    "from": "咸阳城东楼 / 咸阳城西楼晚眺 / 西门",
    "from_who": "许浑",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266055",
    "length": 16
  },
  {
    "id": 5497,
    "uuid": "165984db-9a58-4b83-8351-be2fd42e557e",
    "hitokoto": "晓看天色暮看云，行也思君，坐也思君。",
    "type": "i",
    "from": "一剪梅·雨打梨花深闭门",
    "from_who": "唐寅",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266056",
    "length": 18
  },
  {
    "id": 5498,
    "uuid": "492924f9-e5d4-43da-86c7-c9233a6e72e1",
    "hitokoto": "今人不见古时月，今月曾经照古人。",
    "type": "i",
    "from": "把酒问月·故人贾淳令予问之",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266056",
    "length": 16
  },
  {
    "id": 5499,
    "uuid": "3cd5bf34-449a-48e4-bc13-572c875dd380",
    "hitokoto": "夜月一帘幽梦，春风十里柔情。",
    "type": "i",
    "from": "八六子·倚危亭",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266057",
    "length": 14
  },
  {
    "id": 5500,
    "uuid": "4bcd01c9-911a-4f39-ab3e-5b6ca455d992",
    "hitokoto": "落花人独立，微雨燕双飞。",
    "type": "i",
    "from": "临江仙·梦后楼台高锁",
    "from_who": "晏几道",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266057",
    "length": 12
  },
  {
    "id": 5501,
    "uuid": "dc43136f-42da-449e-b331-f890deb13b07",
    "hitokoto": "劝君莫惜金缕衣，劝君惜取少年时。",
    "type": "i",
    "from": "金缕衣",
    "from_who": "杜秋娘",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266057",
    "length": 16
  },
  {
    "id": 5502,
    "uuid": "2c6e6edd-8ed2-4d2a-ae7b-e96a901452de",
    "hitokoto": "黄沙百战穿金甲，不破楼兰终不还。",
    "type": "i",
    "from": "从军行七首·其四",
    "from_who": "王昌龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266058",
    "length": 16
  },
  {
    "id": 5503,
    "uuid": "bd54446e-fa7c-4aef-bf13-48393c0a24f3",
    "hitokoto": "红酥手，黄縢酒，满城春色宫墙柳。",
    "type": "i",
    "from": "钗头凤·红酥手",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266058",
    "length": 16
  },
  {
    "id": 5504,
    "uuid": "4295121b-832a-4c29-a352-6f7d90c01b58",
    "hitokoto": "凤凰台上凤凰游，凤去台空江自流。",
    "type": "i",
    "from": "登金陵凤凰台",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266058",
    "length": 16
  },
  {
    "id": 5505,
    "uuid": "1abe485c-df3f-43a2-950d-cc6b8b5f9d48",
    "hitokoto": "还君明珠双泪垂，恨不相逢未嫁时。",
    "type": "i",
    "from": "节妇吟·寄东平李司空师道",
    "from_who": "张籍",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266059",
    "length": 16
  },
  {
    "id": 5506,
    "uuid": "82677a36-563a-4641-8713-4f738b61b93a",
    "hitokoto": "宁可枝头抱香死，何曾吹落北风中。",
    "type": "i",
    "from": "画菊",
    "from_who": "郑思肖",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266059",
    "length": 16
  },
  {
    "id": 5507,
    "uuid": "a0fd938e-d2a6-49be-88c4-474345f3afd8",
    "hitokoto": "问君能有几多愁？恰似一江春水向东流。",
    "type": "i",
    "from": "虞美人·春花秋月何时了",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266059",
    "length": 18
  },
  {
    "id": 5508,
    "uuid": "4db50f04-4e55-434f-82ea-c843e0d779d5",
    "hitokoto": "怕相思，已相思，轮到相思没处辞，眉间露一丝。",
    "type": "i",
    "from": "长相思·折花枝",
    "from_who": "俞彦",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266060",
    "length": 22
  },
  {
    "id": 5509,
    "uuid": "78c500e3-40ae-4d89-93ab-c1f8c8deb88e",
    "hitokoto": "空山新雨后，天气晚来秋。",
    "type": "i",
    "from": "山居秋暝",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266060",
    "length": 12
  },
  {
    "id": 5510,
    "uuid": "618fe6a9-58eb-46a2-82c0-de3e0490f4fc",
    "hitokoto": "宠辱不惊，闲看庭前花开花落；去留无意，漫随天外云卷云舒。",
    "type": "i",
    "from": "菜根谭·概论",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266061",
    "length": 28
  },
  {
    "id": 5511,
    "uuid": "31dec965-20b0-492b-820d-b05ec0e40524",
    "hitokoto": "天涯地角有穷时，只有相思无尽处。",
    "type": "i",
    "from": "玉楼春·春恨",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266061",
    "length": 16
  },
  {
    "id": 5512,
    "uuid": "16ff3889-cb86-48fd-b380-5763e0ffb163",
    "hitokoto": "直道相思了无益，未妨惆怅是清狂。",
    "type": "i",
    "from": "无题·重帏深下莫愁堂",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266061",
    "length": 16
  },
  {
    "id": 5513,
    "uuid": "68cbacef-7f02-4902-9f15-651136d66cc0",
    "hitokoto": "一骑红尘妃子笑，无人知是荔枝来。",
    "type": "i",
    "from": "过华清宫绝句三首",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266062",
    "length": 16
  },
  {
    "id": 5514,
    "uuid": "e0e41cd5-48dd-4257-86ac-707d26e02382",
    "hitokoto": "小楼一夜听春雨，深巷明朝卖杏花。",
    "type": "i",
    "from": "临安春雨初霁",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266062",
    "length": 16
  },
  {
    "id": 5515,
    "uuid": "8e3baeeb-2be0-450e-a6a2-19dc000c0b4e",
    "hitokoto": "月上柳梢头，人约黄昏后。",
    "type": "i",
    "from": "生查子·元夕",
    "from_who": "欧阳修",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266062",
    "length": 12
  },
  {
    "id": 5516,
    "uuid": "a9e4b72c-1dda-4872-bca2-5bc74f0721d2",
    "hitokoto": "人言落日是天涯，望极天涯不见家。",
    "type": "i",
    "from": "乡思",
    "from_who": "李觏",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266063",
    "length": 16
  },
  {
    "id": 5517,
    "uuid": "42c30666-7a66-4856-8412-1a84d5b15cb1",
    "hitokoto": "男儿何不带吴钩，收取关山五十州。",
    "type": "i",
    "from": "南园十三首·其五",
    "from_who": "李贺",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266063",
    "length": 16
  },
  {
    "id": 5518,
    "uuid": "a50af3cc-25c6-4fa4-ad6d-32ae0879a6e7",
    "hitokoto": "桃之夭夭，灼灼其华。",
    "type": "i",
    "from": "诗经·周南·桃夭",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266063",
    "length": 10
  },
  {
    "id": 5519,
    "uuid": "2f5d5af3-e9d2-4321-8a09-0d8731d906d0",
    "hitokoto": "待到秋来九月八，我花开后百花杀。",
    "type": "i",
    "from": "不第后赋菊",
    "from_who": "黄巢",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266064",
    "length": 16
  },
  {
    "id": 5520,
    "uuid": "dc5fb92e-b9c2-41fe-b883-76b1dff82597",
    "hitokoto": "二十四桥明月夜，玉人何处教吹箫？",
    "type": "i",
    "from": "寄扬州韩绰判官",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266064",
    "length": 16
  },
  {
    "id": 5521,
    "uuid": "c2de0788-07ef-4baf-964d-ab79c9b6bb7a",
    "hitokoto": "毋意，毋必，毋固，毋我。",
    "type": "i",
    "from": "论语·子罕篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266064",
    "length": 12
  },
  {
    "id": 5522,
    "uuid": "6eadc8d2-1a18-446f-b22c-9fa9968f404f",
    "hitokoto": "枯藤老树昏鸦，小桥流水人家，古道西风瘦马。",
    "type": "i",
    "from": "天净沙·秋思",
    "from_who": "马致远",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266065",
    "length": 21
  },
  {
    "id": 5523,
    "uuid": "49f330fb-9b46-4ae3-8890-cea52f0a7b25",
    "hitokoto": "寂寞空庭春欲晚，梨花满地不开门。",
    "type": "i",
    "from": "春怨",
    "from_who": "刘方平",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266065",
    "length": 16
  },
  {
    "id": 5524,
    "uuid": "a783ef3f-dd77-4b62-b6be-5e071df00f62",
    "hitokoto": "被酒莫惊春睡重，赌书消得泼茶香，当时只道是寻常。",
    "type": "i",
    "from": "浣溪沙·谁念西风独自凉",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266065",
    "length": 24
  },
  {
    "id": 5525,
    "uuid": "0fc10e92-930b-440b-96f1-a3c39121eea2",
    "hitokoto": "不经一番寒彻骨，怎得梅花扑鼻香。",
    "type": "i",
    "from": "上堂开示颂",
    "from_who": "黄蘖禅师",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266066",
    "length": 16
  },
  {
    "id": 5526,
    "uuid": "41891de3-5794-4139-832a-3cdf28e67b09",
    "hitokoto": "青山依旧在，几度夕阳红。",
    "type": "i",
    "from": "临江仙·滚滚长江东逝水",
    "from_who": "杨慎",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266066",
    "length": 12
  },
  {
    "id": 5527,
    "uuid": "43c536af-74e1-43e7-8b10-4db844fae3b4",
    "hitokoto": "海上生明月，天涯共此时。",
    "type": "i",
    "from": "望月怀远",
    "from_who": "张九龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266066",
    "length": 12
  },
  {
    "id": 5528,
    "uuid": "d70c9216-3c2b-4a3d-a28b-f3d056bdd233",
    "hitokoto": "当年不肯嫁春风，无端却被秋风误。",
    "type": "i",
    "from": "芳心苦·杨柳回塘",
    "from_who": "贺铸",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266067",
    "length": 16
  },
  {
    "id": 5529,
    "uuid": "183dca23-6c4d-45fe-85ca-15f1f1329dc2",
    "hitokoto": "纸上得来终觉浅，绝知此事要躬行。",
    "type": "i",
    "from": "冬夜读书示子聿",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266067",
    "length": 16
  },
  {
    "id": 5530,
    "uuid": "f12c12c2-279f-418a-bf74-3fbd202b754c",
    "hitokoto": "东风夜放花千树。更吹落、星如雨。",
    "type": "i",
    "from": "青玉案·元夕",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266068",
    "length": 16
  },
  {
    "id": 5531,
    "uuid": "c3804486-759d-467f-a0d4-bf679e0694c8",
    "hitokoto": "时人不识凌云木，直待凌云始道高。",
    "type": "i",
    "from": "小松",
    "from_who": "杜荀鹤",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266068",
    "length": 16
  },
  {
    "id": 5532,
    "uuid": "304e0586-20b0-4f3c-8105-0928a6950456",
    "hitokoto": "人间四月芳菲尽，山寺桃花始盛开。",
    "type": "i",
    "from": "大林寺桃花",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266068",
    "length": 16
  },
  {
    "id": 5533,
    "uuid": "8968ab01-596f-4634-a5db-b6281f0ee2af",
    "hitokoto": "泪眼问花花不语，乱红飞过秋千去。",
    "type": "i",
    "from": "蝶恋花·庭院深深深几许",
    "from_who": "欧阳修",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266069",
    "length": 16
  },
  {
    "id": 5534,
    "uuid": "8a6b92b5-968a-4a81-bb59-b030b4d84f15",
    "hitokoto": "试问岭南应不好，却道：此心安处是吾乡。",
    "type": "i",
    "from": "少年游·南海归赠王定国侍人寓娘",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266069",
    "length": 19
  },
  {
    "id": 5535,
    "uuid": "c7e9677c-b108-482f-9e1b-a92a81ca1473",
    "hitokoto": "世事漫随流水，算来一梦浮生。",
    "type": "i",
    "from": "乌夜啼·昨夜风兼雨",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266069",
    "length": 14
  },
  {
    "id": 5536,
    "uuid": "81d9e86f-a313-41e1-9b0d-f504bcebdfb0",
    "hitokoto": "江碧鸟逾白，山青花欲燃。",
    "type": "i",
    "from": "绝句二首",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266070",
    "length": 12
  },
  {
    "id": 5537,
    "uuid": "5e4aa55f-57c5-40b4-96ef-0f48516c8c73",
    "hitokoto": "换我心，为你心，始知相忆深。",
    "type": "i",
    "from": "诉衷情·永夜抛人何处去",
    "from_who": "顾夐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266070",
    "length": 14
  },
  {
    "id": 5538,
    "uuid": "18bcfb55-e36c-4dfa-a42a-175a1c2ecc19",
    "hitokoto": "同是天涯沦落人，相逢何必曾相识！",
    "type": "i",
    "from": "琵琶行 / 琵琶引",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266070",
    "length": 16
  },
  {
    "id": 5539,
    "uuid": "f98d0260-4c8e-4a15-9cbd-4a6888a67aa4",
    "hitokoto": "醉卧沙场君莫笑，古来征战几人回？",
    "type": "i",
    "from": "凉州词二首·其一",
    "from_who": "王翰",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266071",
    "length": 16
  },
  {
    "id": 5540,
    "uuid": "519593c5-f62a-4027-b140-e2165c0ab5bd",
    "hitokoto": "苟利国家生死以，岂因祸福避趋之！",
    "type": "i",
    "from": "赴戍登程口占示家人·其二",
    "from_who": "林则徐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266071",
    "length": 16
  },
  {
    "id": 5541,
    "uuid": "0d4ccd01-a095-4d7c-9615-acda3502351e",
    "hitokoto": "十年磨一剑，霜刃未曾试。",
    "type": "i",
    "from": "剑客 / 述剑",
    "from_who": "贾岛",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266071",
    "length": 12
  },
  {
    "id": 5542,
    "uuid": "348f4baa-9347-4325-8bf4-b3d107904c67",
    "hitokoto": "落霞与孤鹜齐飞，秋水共长天一色。",
    "type": "i",
    "from": "滕王阁序",
    "from_who": "王勃",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266072",
    "length": 16
  },
  {
    "id": 5543,
    "uuid": "4e7f5ff6-bc02-4b69-af89-b00884c5bf67",
    "hitokoto": "生当复来归，死当长相思。",
    "type": "i",
    "from": "留别妻",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266072",
    "length": 12
  },
  {
    "id": 5544,
    "uuid": "74928e43-b0f5-4783-932d-528a46d0ed9a",
    "hitokoto": "莫愁前路无知己，天下谁人不识君。",
    "type": "i",
    "from": "别董大二首",
    "from_who": "高适",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266073",
    "length": 16
  },
  {
    "id": 5545,
    "uuid": "5d9def79-c283-4c4c-a9cb-f44ac8da26da",
    "hitokoto": "采得百花成蜜后，为谁辛苦为谁甜。",
    "type": "i",
    "from": "蜂",
    "from_who": "罗隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266392",
    "length": 16
  },
  {
    "id": 5546,
    "uuid": "2a768424-a076-47dc-b852-a8e024e305cd",
    "hitokoto": "闻君有两意，故来相决绝。",
    "type": "i",
    "from": "白头吟",
    "from_who": "卓文君",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266393",
    "length": 12
  },
  {
    "id": 5547,
    "uuid": "0c329aae-e0c8-4ac7-a2ff-08dedac04f12",
    "hitokoto": "日日思君不见君，共饮长江水。",
    "type": "i",
    "from": "卜算子·我住长江头",
    "from_who": "李之仪",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266393",
    "length": 14
  },
  {
    "id": 5548,
    "uuid": "365fd952-64d8-4653-98fe-a1f52404dff4",
    "hitokoto": "独自莫凭栏，无限江山，别时容易见时难。",
    "type": "i",
    "from": "浪淘沙令·帘外雨潺潺",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266393",
    "length": 19
  },
  {
    "id": 5549,
    "uuid": "ae2ba359-12aa-4dd6-a6fc-d1f770450269",
    "hitokoto": "读书不觉已春深，一寸光阴一寸金。",
    "type": "i",
    "from": "白鹿洞二首·其一",
    "from_who": "王贞白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266394",
    "length": 16
  },
  {
    "id": 5550,
    "uuid": "d3a4ca24-1846-4301-a068-a46e33db5956",
    "hitokoto": "梅须逊雪三分白，雪却输梅一段香。",
    "type": "i",
    "from": "雪梅·其一",
    "from_who": "卢梅坡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266394",
    "length": 16
  },
  {
    "id": 5551,
    "uuid": "2d0df74d-e9df-4000-b0d6-3a58baabf9de",
    "hitokoto": "多情自古伤离别，更那堪冷落清秋节！",
    "type": "i",
    "from": "雨霖铃·寒蝉凄切",
    "from_who": "柳永",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266394",
    "length": 17
  },
  {
    "id": 5552,
    "uuid": "d055eba0-8375-4771-b617-5e669b2b7fb0",
    "hitokoto": "心似双丝网，中有千千结。",
    "type": "i",
    "from": "千秋岁·数声鶗鴂",
    "from_who": "张先",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266395",
    "length": 12
  },
  {
    "id": 5553,
    "uuid": "2cb88c31-d01f-4735-a2cf-f7f076f0e40d",
    "hitokoto": "风萧萧兮易水寒，壮士一去兮不复还。",
    "type": "i",
    "from": "荆轲歌 / 渡易水歌",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266395",
    "length": 17
  },
  {
    "id": 5554,
    "uuid": "dbb61cbd-1b92-427f-97d5-7788698efb01",
    "hitokoto": "露从今夜白，月是故乡明。",
    "type": "i",
    "from": "月夜忆舍弟",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266395",
    "length": 12
  },
  {
    "id": 5555,
    "uuid": "e96c98c7-02d8-406e-b964-7dce2d3f3af8",
    "hitokoto": "无可奈何花落去，似曾相识燕归来。",
    "type": "i",
    "from": "浣溪沙·一曲新词酒一杯",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266396",
    "length": 16
  },
  {
    "id": 5556,
    "uuid": "2aa15d79-e10f-4a59-b8bc-3716f2c22fcc",
    "hitokoto": "相思相见知何日？此时此夜难为情！",
    "type": "i",
    "from": "三五七言 / 秋风词",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266396",
    "length": 16
  },
  {
    "id": 5557,
    "uuid": "ff7c7b7e-4089-4bff-a7b8-cbe00db6311f",
    "hitokoto": "独立寒秋，湘江北去，橘子洲头。",
    "type": "i",
    "from": "沁园春·长沙",
    "from_who": "毛泽东",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266396",
    "length": 15
  },
  {
    "id": 5558,
    "uuid": "5b12ff5f-198c-41cf-b700-615b98ae81ac",
    "hitokoto": "众里寻他千百度。蓦然回首，那人却在，灯火阑珊处。",
    "type": "i",
    "from": "青玉案·元夕",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266397",
    "length": 24
  },
  {
    "id": 5559,
    "uuid": "a6c591ae-1299-4f05-987f-3c423b4f21cb",
    "hitokoto": "美人自刎乌江岸，战火曾烧赤壁山，将军空老玉门关。",
    "type": "i",
    "from": "卖花声·怀古",
    "from_who": "张可久",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266397",
    "length": 24
  },
  {
    "id": 5560,
    "uuid": "323c26e4-3f46-4c26-9db8-301e24953374",
    "hitokoto": "夜来幽梦忽还乡。小轩窗。正梳妆。相顾无言，惟有泪千行。",
    "type": "i",
    "from": "江城子·乙卯正月二十日夜记梦",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266398",
    "length": 27
  },
  {
    "id": 5561,
    "uuid": "cdb6ff4a-cc4a-4de3-a933-d27e5b2ed930",
    "hitokoto": "晚来天欲雪，能饮一杯无。",
    "type": "i",
    "from": "问刘十九",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266398",
    "length": 12
  },
  {
    "id": 5562,
    "uuid": "231fb364-666f-4443-81f2-7f44d65b98cb",
    "hitokoto": "把酒祝东风。且共从容。",
    "type": "i",
    "from": "浪淘沙·把酒祝东风",
    "from_who": "欧阳修",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266398",
    "length": 11
  },
  {
    "id": 5563,
    "uuid": "3fc3defd-0aca-4244-aad9-d3a4a5d4f3bc",
    "hitokoto": "春蚕到死丝方尽，蜡炬成灰泪始干。",
    "type": "i",
    "from": "无题·相见时难别亦难",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266399",
    "length": 16
  },
  {
    "id": 5564,
    "uuid": "5b57f71a-8b3b-42ac-a8a7-5be6964219b0",
    "hitokoto": "欲买桂花同载酒，终不似、少年游。",
    "type": "i",
    "from": "唐多令·芦叶满汀洲",
    "from_who": "刘过",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266399",
    "length": 16
  },
  {
    "id": 5565,
    "uuid": "dfda37fe-478f-4d36-99c4-634650641f9b",
    "hitokoto": "最是人间留不住，朱颜辞镜花辞树。",
    "type": "i",
    "from": "蝶恋花·阅尽天涯离别苦",
    "from_who": "王国维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266399",
    "length": 16
  },
  {
    "id": 5566,
    "uuid": "ffa3a30d-e0c9-41b3-8479-494cfbb9237a",
    "hitokoto": "锦瑟无端五十弦，一弦一柱思华年。",
    "type": "i",
    "from": "锦瑟",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266400",
    "length": 16
  },
  {
    "id": 5567,
    "uuid": "43124c7e-ad63-46b1-b362-0616a57b64aa",
    "hitokoto": "物是人非事事休，欲语泪先流。",
    "type": "i",
    "from": "武陵春·春晚",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266400",
    "length": 14
  },
  {
    "id": 5568,
    "uuid": "fbfdcaf9-2859-444a-ba86-9ea9f9c07b25",
    "hitokoto": "月有盈亏花有开谢，想人生最苦离别。",
    "type": "i",
    "from": "普天乐·咏世",
    "from_who": "张鸣善",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266400",
    "length": 17
  },
  {
    "id": 5569,
    "uuid": "9bf5bfb3-1344-46d4-9eed-ed1103118e23",
    "hitokoto": "沉舟侧畔千帆过，病树前头万木春。",
    "type": "i",
    "from": "酬乐天扬州初逢席上见赠",
    "from_who": "刘禹锡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266401",
    "length": 16
  },
  {
    "id": 5570,
    "uuid": "302ae147-73e9-4d52-a3c8-8c7d19409cec",
    "hitokoto": "盈盈一水间，脉脉不得语。",
    "type": "i",
    "from": "迢迢牵牛星",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266401",
    "length": 12
  },
  {
    "id": 5571,
    "uuid": "73e31c16-e19a-4331-b5f4-53922549686b",
    "hitokoto": "射人先射马，擒贼先擒王。",
    "type": "i",
    "from": "前出塞九首·其六",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266402",
    "length": 12
  },
  {
    "id": 5572,
    "uuid": "0132e873-f765-43df-b9e9-8865c032c8ba",
    "hitokoto": "我见青山多妩媚，料青山见我应如是。",
    "type": "i",
    "from": "贺新郎·甚矣吾衰矣",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266402",
    "length": 17
  },
  {
    "id": 5573,
    "uuid": "190a2d4d-8239-427a-a0b2-e935c49ebf2c",
    "hitokoto": "竹外桃花三两枝，春江水暖鸭先知。",
    "type": "i",
    "from": "惠崇春江晚景 / 惠崇春江晓景",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266402",
    "length": 16
  },
  {
    "id": 5574,
    "uuid": "d1972224-fbc7-4b25-8569-fa9f9132f9e2",
    "hitokoto": "山外青山楼外楼，西湖歌舞几时休？",
    "type": "i",
    "from": "题临安邸",
    "from_who": "林升",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266403",
    "length": 16
  },
  {
    "id": 5575,
    "uuid": "06ce7b01-36e4-49fe-a9f0-b8454562d3b6",
    "hitokoto": "伤心桥下春波绿，曾是惊鸿照影来。",
    "type": "i",
    "from": "沈园二首",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266403",
    "length": 16
  },
  {
    "id": 5576,
    "uuid": "b934b129-67ae-41d9-b81f-fc30b90d76b6",
    "hitokoto": "大江东去，浪淘尽，千古风流人物。",
    "type": "i",
    "from": "念奴娇·赤壁怀古",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266403",
    "length": 16
  },
  {
    "id": 5577,
    "uuid": "4349ead0-124c-4bfe-846a-90dd44264ca2",
    "hitokoto": "君子有九思：视思明，听思聪，色思温，貌思恭，言思忠，事思敬，疑思问，忿思难，见得思义。",
    "type": "i",
    "from": "论语·季氏篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266404",
    "length": 43
  },
  {
    "id": 5578,
    "uuid": "77a33f55-1b63-419c-a3b2-ec01dc7746cd",
    "hitokoto": "落红不是无情物，化作春泥更护花。",
    "type": "i",
    "from": "己亥杂诗·其五",
    "from_who": "龚自珍",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266404",
    "length": 16
  },
  {
    "id": 5579,
    "uuid": "ba330b0e-da3d-41f4-b8ca-24eece4ad324",
    "hitokoto": "酒入愁肠，化作相思泪。",
    "type": "i",
    "from": "苏幕遮·怀旧",
    "from_who": "范仲淹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266404",
    "length": 11
  },
  {
    "id": 5580,
    "uuid": "3cb84ce8-2491-4087-b809-b119ce2102d9",
    "hitokoto": "呜呼！楚虽三户能亡秦，岂有堂堂中国空无人！",
    "type": "i",
    "from": "金错刀行",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266405",
    "length": 21
  },
  {
    "id": 5581,
    "uuid": "b0292765-7749-456f-9aad-7a8f0b8a9a14",
    "hitokoto": "夕阳无限好，只是近黄昏。",
    "type": "i",
    "from": "乐游原 / 登乐游原",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266405",
    "length": 12
  },
  {
    "id": 5582,
    "uuid": "e242a634-56f3-4ed3-9e70-9c3ef1888e09",
    "hitokoto": "酒逢知己千杯少，话不投机半句多。",
    "type": "i",
    "from": "明贤集·七言集",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266405",
    "length": 16
  },
  {
    "id": 5583,
    "uuid": "690bf909-e2f4-4029-9e79-4661a8026917",
    "hitokoto": "衣带渐宽终不悔，为伊消得人憔悴。",
    "type": "i",
    "from": "蝶恋花·伫倚危楼风细细",
    "from_who": "柳永",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266406",
    "length": 16
  },
  {
    "id": 5584,
    "uuid": "564d9b56-dc78-42e6-8a05-8b5a0e733803",
    "hitokoto": "世人结交须黄金，黄金不多交不深。",
    "type": "i",
    "from": "题长安壁主人",
    "from_who": "张谓",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266406",
    "length": 16
  },
  {
    "id": 5585,
    "uuid": "488f52cd-a6c8-4e79-97cb-cc6ce207892d",
    "hitokoto": "渺万里层云，千山暮雪，只影向谁去？",
    "type": "i",
    "from": "摸鱼儿·雁丘词 / 迈陂塘",
    "from_who": "元好问",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266406",
    "length": 17
  },
  {
    "id": 5586,
    "uuid": "71ebf0e8-9bf4-4fe5-afd9-5b0b0faeb927",
    "hitokoto": "遇酒且呵呵，人生能几何！",
    "type": "i",
    "from": "菩萨蛮·劝君今夜须沈醉",
    "from_who": "韦庄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266407",
    "length": 12
  },
  {
    "id": 5587,
    "uuid": "c9d7ffc5-fd38-4bb7-8e34-2102ddd98a24",
    "hitokoto": "天长地久有时尽，此恨绵绵无绝期。",
    "type": "i",
    "from": "长恨歌",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266407",
    "length": 16
  },
  {
    "id": 5588,
    "uuid": "13e53cb2-58af-4522-8d59-1de37e530df3",
    "hitokoto": "世事短如春梦，人情薄似秋云。",
    "type": "i",
    "from": "西江月·世事短如春梦",
    "from_who": "朱敦儒",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266407",
    "length": 14
  },
  {
    "id": 5589,
    "uuid": "46f758f8-a1f1-4086-8742-598e9eb8d1ba",
    "hitokoto": "长风破浪会有时，直挂云帆济沧海。",
    "type": "i",
    "from": "行路难·其一",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266408",
    "length": 16
  },
  {
    "id": 5590,
    "uuid": "3f7ffa61-e42f-4bdb-949d-830680c19eae",
    "hitokoto": "人闲桂花落，夜静春山空。",
    "type": "i",
    "from": "鸟鸣涧",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266408",
    "length": 12
  },
  {
    "id": 5591,
    "uuid": "23d45b52-7709-4fb2-9ba8-2fe027cf6399",
    "hitokoto": "渐行渐远渐无书，水阔鱼沉何处问。",
    "type": "i",
    "from": "玉楼春·别后不知君远近",
    "from_who": "欧阳修",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266408",
    "length": 16
  },
  {
    "id": 5592,
    "uuid": "3071e935-9d13-47e3-8996-771f6d34c6ce",
    "hitokoto": "花间一壶酒，独酌无相亲。",
    "type": "i",
    "from": "月下独酌四首·其一",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266409",
    "length": 12
  },
  {
    "id": 5593,
    "uuid": "f650b952-48d7-46f2-905c-799fecd1b1fa",
    "hitokoto": "春风十里扬州路，卷上珠帘总不如。",
    "type": "i",
    "from": "赠别",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266409",
    "length": 16
  },
  {
    "id": 5594,
    "uuid": "e8f4ee1c-e21a-4996-8c6d-b35621604ef9",
    "hitokoto": "系我一生心，负你千行泪。",
    "type": "i",
    "from": "忆帝京·薄衾小枕凉天气",
    "from_who": "柳永",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266410",
    "length": 12
  },
  {
    "id": 5595,
    "uuid": "02b68b6d-d8cc-4f13-a711-910957b61c71",
    "hitokoto": "他年我若为青帝，报与桃花一处开。",
    "type": "i",
    "from": "题菊花",
    "from_who": "黄巢",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266410",
    "length": 16
  },
  {
    "id": 5596,
    "uuid": "a5a74dc7-05f1-4109-9e92-2d2957968b75",
    "hitokoto": "白日放歌须纵酒，青春作伴好还乡。",
    "type": "i",
    "from": "闻官军收河南河北",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266410",
    "length": 16
  },
  {
    "id": 5597,
    "uuid": "d338aae0-f7f1-4196-bf28-c79511f7565c",
    "hitokoto": "花无人戴，酒无人劝，醉也无人管。",
    "type": "i",
    "from": "青玉案·年年社日停针线",
    "from_who": "黄公绍",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266411",
    "length": 16
  },
  {
    "id": 5598,
    "uuid": "b6676611-75ed-4df9-97a7-7dd717d83d9d",
    "hitokoto": "韶华不为少年留。恨悠悠。几时休。",
    "type": "i",
    "from": "江城子·西城杨柳弄春柔",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266411",
    "length": 16
  },
  {
    "id": 5599,
    "uuid": "3ed1e7a0-f0e6-4223-ad65-3666bc256855",
    "hitokoto": "江南无所有，聊赠一枝春。",
    "type": "i",
    "from": "赠范晔诗",
    "from_who": "陆凯",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266412",
    "length": 12
  },
  {
    "id": 5600,
    "uuid": "e8ccd960-98f6-45f5-bd2d-073414baf071",
    "hitokoto": "海水梦悠悠，君愁我亦愁。",
    "type": "i",
    "from": "西洲曲",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266412",
    "length": 12
  },
  {
    "id": 5601,
    "uuid": "f42fe92f-7d10-4afd-ba5e-17354873d4ca",
    "hitokoto": "美人卷珠帘，深坐颦蛾眉。",
    "type": "i",
    "from": "怨情",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266412",
    "length": 12
  },
  {
    "id": 5602,
    "uuid": "977266aa-edc7-4c37-8467-9395c15aac2e",
    "hitokoto": "金风玉露一相逢，便胜却人间无数。",
    "type": "i",
    "from": "鹊桥仙·纤云弄巧",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266413",
    "length": 16
  },
  {
    "id": 5603,
    "uuid": "d39dad64-8d1d-4bdb-be7d-e213e1e4214e",
    "hitokoto": "衰兰送客咸阳道，天若有情天亦老。",
    "type": "i",
    "from": "行路难·缚虎手",
    "from_who": "贺铸",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266413",
    "length": 16
  },
  {
    "id": 5604,
    "uuid": "694cb000-8f27-4472-9ff2-a2657e037cf1",
    "hitokoto": "江南可采莲，莲叶何田田。",
    "type": "i",
    "from": "江南",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266413",
    "length": 12
  },
  {
    "id": 5605,
    "uuid": "9671bb43-f26d-441d-b04a-665852ef2e99",
    "hitokoto": "山一程，水一程，身向榆关那畔行，夜深千帐灯。",
    "type": "i",
    "from": "长相思·山一程",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266483",
    "length": 22
  },
  {
    "id": 5606,
    "uuid": "54c2def3-89a2-4c23-9bd9-79349af563b4",
    "hitokoto": "夜阑卧听风吹雨，铁马冰河入梦来。",
    "type": "i",
    "from": "十一月四日风雨大作",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266484",
    "length": 16
  },
  {
    "id": 5607,
    "uuid": "1f5bd366-3070-4ea5-94b3-ad327b8116a6",
    "hitokoto": "天下熙熙，皆为利来；天下攘攘，皆为利往。",
    "type": "i",
    "from": "史记·货殖列传",
    "from_who": "司马迁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266484",
    "length": 20
  },
  {
    "id": 5608,
    "uuid": "c16541df-53ab-4a46-8896-feb1833af0f0",
    "hitokoto": "相见时难别亦难，东风无力百花残。",
    "type": "i",
    "from": "无题·相见时难别亦难",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266484",
    "length": 16
  },
  {
    "id": 5609,
    "uuid": "bb3cf064-bfc3-42c7-a566-6da15be2fca1",
    "hitokoto": "少年易老学难成，一寸光阴不可轻。",
    "type": "i",
    "from": "劝学诗 / 偶成",
    "from_who": "朱熹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266485",
    "length": 16
  },
  {
    "id": 5610,
    "uuid": "d647239d-f512-4146-87d0-74e216e640d9",
    "hitokoto": "相思只在：丁香枝上，豆蔻梢头。",
    "type": "i",
    "from": "眼儿媚·杨柳丝丝弄轻柔",
    "from_who": "王雱",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266485",
    "length": 15
  },
  {
    "id": 5611,
    "uuid": "b4bf6155-60c5-41d1-8ee8-2c642d02d716",
    "hitokoto": "万事到头都是梦，休休。明日黄花蝶也愁。",
    "type": "i",
    "from": "南乡子·重九涵辉楼呈徐君猷",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266485",
    "length": 19
  },
  {
    "id": 5612,
    "uuid": "9b370715-7c0d-48b3-ac7d-de37076ee562",
    "hitokoto": "流水落花春去也，天上人间。",
    "type": "i",
    "from": "浪淘沙令·帘外雨潺潺",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266486",
    "length": 13
  },
  {
    "id": 5613,
    "uuid": "fecc2820-2329-4cc0-aa4e-5c7a29b52a37",
    "hitokoto": "兰有秀兮菊有芳，怀佳人兮不能忘。",
    "type": "i",
    "from": "秋风辞",
    "from_who": "刘彻",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266486",
    "length": 16
  },
  {
    "id": 5614,
    "uuid": "323a29a1-28a1-4ee5-9aa1-a53e0f418247",
    "hitokoto": "若教眼底无离恨，不信人间有白头。",
    "type": "i",
    "from": "鹧鸪天·晚日寒鸦一片愁",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266486",
    "length": 16
  },
  {
    "id": 5615,
    "uuid": "04c3ada3-7824-45aa-844e-6c7846915151",
    "hitokoto": "旧时王谢堂前燕，飞入寻常百姓家。",
    "type": "i",
    "from": "乌衣巷",
    "from_who": "刘禹锡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266487",
    "length": 16
  },
  {
    "id": 5616,
    "uuid": "89b38b7f-5d20-4276-9b3b-f58c521ece18",
    "hitokoto": "思君如满月，夜夜减清辉。",
    "type": "i",
    "from": "赋得自君之出矣",
    "from_who": "张九龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266487",
    "length": 12
  },
  {
    "id": 5617,
    "uuid": "788568ed-bc3f-43ed-9f22-e8499f9e8f12",
    "hitokoto": "力拔山兮气盖世。时不利兮骓不逝。",
    "type": "i",
    "from": "垓下歌",
    "from_who": "项羽",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266488",
    "length": 16
  },
  {
    "id": 5618,
    "uuid": "24a17d59-cdc1-453a-8a9f-debde3428221",
    "hitokoto": "昨夜星辰昨夜风，画楼西畔桂堂东。",
    "type": "i",
    "from": "无题·昨夜星辰昨夜风",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266488",
    "length": 16
  },
  {
    "id": 5619,
    "uuid": "fb8be48f-0c9a-44d5-ad94-69ce22974849",
    "hitokoto": "秦时明月汉时关，万里长征人未还。",
    "type": "i",
    "from": "出塞二首·其一",
    "from_who": "王昌龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266488",
    "length": 16
  },
  {
    "id": 5620,
    "uuid": "e06b12b2-f76b-4500-90ba-a97efbc8071b",
    "hitokoto": "欲把相思说似谁，浅情人不知。",
    "type": "i",
    "from": "长相思·长相思",
    "from_who": "晏几道",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266489",
    "length": 14
  },
  {
    "id": 5621,
    "uuid": "48c20247-5dce-4ad5-981e-47a80058ae2d",
    "hitokoto": "无边落木萧萧下，不尽长江滚滚来。",
    "type": "i",
    "from": "登高",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266489",
    "length": 16
  },
  {
    "id": 5622,
    "uuid": "58018b10-603b-4b85-a007-4fdfa4e22529",
    "hitokoto": "人间有味是清欢。",
    "type": "i",
    "from": "浣溪沙·细雨斜风作晓寒",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266489",
    "length": 8
  },
  {
    "id": 5623,
    "uuid": "faa56a2d-76fd-4b6b-b08e-1cb8d3e75318",
    "hitokoto": "人生天地之间，若白驹之过隙，忽然而已。",
    "type": "i",
    "from": "庄子·外篇·知北游",
    "from_who": "庄子休",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266490",
    "length": 19
  },
  {
    "id": 5624,
    "uuid": "4cae5e2c-9dd8-4614-810b-4b9a7aae7ae8",
    "hitokoto": "少年听雨歌楼上。红烛昏罗帐。",
    "type": "i",
    "from": "虞美人·听雨",
    "from_who": "蒋捷",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266490",
    "length": 14
  },
  {
    "id": 5625,
    "uuid": "ccfb877b-e44a-48fa-b5dc-dcc05d9073d1",
    "hitokoto": "人到情多情转薄，而今真个不多情。",
    "type": "i",
    "from": "山花子·风絮飘残已化萍",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266491",
    "length": 16
  },
  {
    "id": 5626,
    "uuid": "8fed9321-dfcd-4ddb-a2bf-00c962fc7374",
    "hitokoto": "枝上柳绵吹又少。天涯何处无芳草。",
    "type": "i",
    "from": "蝶恋花·春景",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266491",
    "length": 16
  },
  {
    "id": 5627,
    "uuid": "659a98fa-5dd4-4c9c-840a-0acb285f62ec",
    "hitokoto": "天街小雨润如酥，草色遥看近却无。",
    "type": "i",
    "from": "早春呈水部张十八员外 / 初春小雨 / 早春",
    "from_who": "韩愈",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266492",
    "length": 16
  },
  {
    "id": 5628,
    "uuid": "8fd23bd8-0b84-4474-a2b6-937123b60b29",
    "hitokoto": "结发为夫妻，恩爱两不疑。",
    "type": "i",
    "from": "留别妻",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266493",
    "length": 12
  },
  {
    "id": 5629,
    "uuid": "838d7395-543b-46f9-9840-3710a5cf0ef8",
    "hitokoto": "春江潮水连海平，海上明月共潮生。",
    "type": "i",
    "from": "春江花月夜",
    "from_who": "张若虚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266493",
    "length": 16
  },
  {
    "id": 5630,
    "uuid": "00dfc983-b8ce-4f92-a48b-cbe118260cda",
    "hitokoto": "莫唱当年长恨歌，人间亦自有银河。",
    "type": "i",
    "from": "马嵬",
    "from_who": "袁枚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266494",
    "length": 16
  },
  {
    "id": 5631,
    "uuid": "20c7b0b0-33ea-4e90-9a19-14eabbe774a3",
    "hitokoto": "愿得此身长报国，何须生入玉门关。",
    "type": "i",
    "from": "塞上曲二首·其二",
    "from_who": "戴叔伦",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266494",
    "length": 16
  },
  {
    "id": 5632,
    "uuid": "0dbd8aa4-8527-40d1-8ff0-163d021577bd",
    "hitokoto": "云中谁寄锦书来，雁字回时，月满西楼。",
    "type": "i",
    "from": "一剪梅·红藕香残玉簟秋",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266495",
    "length": 18
  },
  {
    "id": 5633,
    "uuid": "ec5057af-156c-4284-a5f4-9843560372e7",
    "hitokoto": "月落乌啼霜满天，江枫渔火对愁眠。",
    "type": "i",
    "from": "枫桥夜泊 / 夜泊枫江",
    "from_who": "张继",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266495",
    "length": 16
  },
  {
    "id": 5634,
    "uuid": "4a256755-fed1-4c82-a230-9fd80b13fc63",
    "hitokoto": "山重水复疑无路，柳暗花明又一村。",
    "type": "i",
    "from": "游山西村",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266495",
    "length": 16
  },
  {
    "id": 5635,
    "uuid": "d4d3f2e4-28fe-46fc-a109-8fcc2581a82e",
    "hitokoto": "寻寻觅觅，冷冷清清，凄凄惨惨戚戚。",
    "type": "i",
    "from": "声声慢·寻寻觅觅",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266496",
    "length": 17
  },
  {
    "id": 5636,
    "uuid": "04ec54d2-e296-4d61-a3f2-9f3b3c643af8",
    "hitokoto": "宣父犹能畏后生，丈夫未可轻年少。",
    "type": "i",
    "from": "上李邕",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266496",
    "length": 16
  },
  {
    "id": 5637,
    "uuid": "bcbdf1dd-29e1-4969-aca1-c1cd5afc799e",
    "hitokoto": "危楼高百尺，手可摘星辰。",
    "type": "i",
    "from": "夜宿山寺",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266496",
    "length": 12
  },
  {
    "id": 5638,
    "uuid": "d361e4f9-47e9-42ad-ae18-1b4fd9b91669",
    "hitokoto": "小荷才露尖尖角，早有蜻蜓立上头。",
    "type": "i",
    "from": "小池",
    "from_who": "杨万里",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266497",
    "length": 16
  },
  {
    "id": 5639,
    "uuid": "9cf87566-1732-41ac-9efa-489554886aba",
    "hitokoto": "成事不说，遂事不谏，既往不咎。",
    "type": "i",
    "from": "论语·八佾篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266497",
    "length": 15
  },
  {
    "id": 5640,
    "uuid": "42cd9ae5-c048-4307-8c46-eb32cd8efaa8",
    "hitokoto": "我欲穿花寻路，直入白云深处，浩气展虹霓。",
    "type": "i",
    "from": "水调歌头·游览",
    "from_who": "黄庭坚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266497",
    "length": 20
  },
  {
    "id": 5641,
    "uuid": "7d8a6229-1e7b-45bb-a98e-70f31e935544",
    "hitokoto": "春风又绿江南岸，明月何时照我还？",
    "type": "i",
    "from": "泊船瓜洲",
    "from_who": "王安石",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266498",
    "length": 16
  },
  {
    "id": 5642,
    "uuid": "ad85f3c0-31ec-4c82-814a-8d59d1d06ba9",
    "hitokoto": "蝉噪林逾静，鸟鸣山更幽。",
    "type": "i",
    "from": "入若耶溪",
    "from_who": "王籍",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266498",
    "length": 12
  },
  {
    "id": 5643,
    "uuid": "8057041c-ad1c-4b0a-b636-70504403c4aa",
    "hitokoto": "世情薄，人情恶，雨送黄昏花易落。",
    "type": "i",
    "from": "钗头凤·世情薄",
    "from_who": "唐婉",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266498",
    "length": 16
  },
  {
    "id": 5644,
    "uuid": "e245396b-331b-48b4-89f9-877f8a8ce47c",
    "hitokoto": "洛阳亲友如相问，一片冰心在玉壶。",
    "type": "i",
    "from": "芙蓉楼送辛渐",
    "from_who": "王昌龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586266499",
    "length": 16
  },
  {
    "id": 5645,
    "uuid": "d7b65ac4-4c9f-4164-8b65-148e4bc65dec",
    "hitokoto": "春心莫共花争发，一寸相思一寸灰！",
    "type": "i",
    "from": "无题·飒飒东风细雨来",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271513",
    "length": 16
  },
  {
    "id": 5646,
    "uuid": "4d41d306-7fbf-449d-b46e-18ada1b36f0c",
    "hitokoto": "年年岁岁花相似，岁岁年年人不同。",
    "type": "i",
    "from": "代悲白头翁 / 白头吟 / 有所思",
    "from_who": "刘希夷",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271513",
    "length": 16
  },
  {
    "id": 5647,
    "uuid": "0afdc1ab-ea93-447a-9f0e-736ab16dbace",
    "hitokoto": "十年一觉扬州梦，赢得青楼薄幸名。",
    "type": "i",
    "from": "遣怀",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271513",
    "length": 16
  },
  {
    "id": 5648,
    "uuid": "b545bc97-d1c5-4a47-bdd1-7eaa4cb1239e",
    "hitokoto": "东边日出西边雨，道是无晴却有晴。",
    "type": "i",
    "from": "竹枝词二首·其一",
    "from_who": "刘禹锡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271514",
    "length": 16
  },
  {
    "id": 5649,
    "uuid": "45613f4d-b668-42fd-a2c9-bdd0cee395b6",
    "hitokoto": "青青子衿，悠悠我心。",
    "type": "i",
    "from": "诗经·郑风·子衿",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271514",
    "length": 10
  },
  {
    "id": 5650,
    "uuid": "c0daadc0-6887-47ff-9365-2b2cdd270916",
    "hitokoto": "肠已断，泪难收。相思重上小红楼。",
    "type": "i",
    "from": "鹧鸪天·晚日寒鸦一片愁",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271515",
    "length": 16
  },
  {
    "id": 5651,
    "uuid": "3d5fee9f-f124-4080-bbaf-0b1dfa8261af",
    "hitokoto": "愿为西南风，长逝入君怀。",
    "type": "i",
    "from": "明月上高楼",
    "from_who": "曹植",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271515",
    "length": 12
  },
  {
    "id": 5652,
    "uuid": "c4c7de80-5fe8-4353-a446-a42b7988745b",
    "hitokoto": "多情只有春庭月，犹为离人照落花。",
    "type": "i",
    "from": "寄人",
    "from_who": "张泌",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271515",
    "length": 16
  },
  {
    "id": 5653,
    "uuid": "51c35c88-7fd1-46ff-ae60-86af04f20045",
    "hitokoto": "红豆生南国，春来发几枝。",
    "type": "i",
    "from": "相思",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271516",
    "length": 12
  },
  {
    "id": 5654,
    "uuid": "eefb51c9-2054-4b8d-80bd-0c933e6b2d3e",
    "hitokoto": "谁念西风独自凉，萧萧黄叶闭疏窗，沉思往事立残阳。",
    "type": "i",
    "from": "浣溪沙·谁念西风独自凉",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271516",
    "length": 24
  },
  {
    "id": 5655,
    "uuid": "f02f2a24-2bd2-4593-9f10-b099cd3d2549",
    "hitokoto": "昔去雪如花，今来花似雪。",
    "type": "i",
    "from": "别诗",
    "from_who": "范云",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271517",
    "length": 12
  },
  {
    "id": 5656,
    "uuid": "910c1560-6f37-4b06-a1a6-ae0100034f07",
    "hitokoto": "大漠孤烟直，长河落日圆。",
    "type": "i",
    "from": "使至塞上",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271517",
    "length": 12
  },
  {
    "id": 5657,
    "uuid": "f1d0457d-533c-4833-a41d-995b2e462f3d",
    "hitokoto": "位卑未敢忘忧国，事定犹须待阖棺。",
    "type": "i",
    "from": "病起书怀",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271517",
    "length": 16
  },
  {
    "id": 5658,
    "uuid": "68bf6900-4068-418b-938e-5ac40a159fc3",
    "hitokoto": "咬定青山不放松，立根原在破岩中。",
    "type": "i",
    "from": "竹石",
    "from_who": "郑燮",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271518",
    "length": 16
  },
  {
    "id": 5659,
    "uuid": "fc4b6ee1-e2be-4b96-a3c5-bb5f1bf2204f",
    "hitokoto": "大鹏一日同风起，扶摇直上九万里。",
    "type": "i",
    "from": "上李邕",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271518",
    "length": 16
  },
  {
    "id": 5660,
    "uuid": "21a562f8-ee11-42ff-9cec-328dd5eebaed",
    "hitokoto": "松花酿酒，春水煎茶。",
    "type": "i",
    "from": "人月圆·山中书事",
    "from_who": "张可久",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271518",
    "length": 10
  },
  {
    "id": 5661,
    "uuid": "ea9685ec-7700-4260-9de2-5584aa8ab1dd",
    "hitokoto": "曾与美人桥上别，恨无消息到今朝。",
    "type": "i",
    "from": "杨柳枝 / 柳枝词",
    "from_who": "刘禹锡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271519",
    "length": 16
  },
  {
    "id": 5662,
    "uuid": "1c5d5e81-8818-47b7-9126-06ead904c1c1",
    "hitokoto": "落叶他乡树，寒灯独夜人。",
    "type": "i",
    "from": "灞上秋居",
    "from_who": "马戴",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271519",
    "length": 12
  },
  {
    "id": 5663,
    "uuid": "a4ea4023-31ff-48ab-a193-910f9984f460",
    "hitokoto": "远看山有色，近听水无声。",
    "type": "i",
    "from": "画",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271519",
    "length": 12
  },
  {
    "id": 5664,
    "uuid": "8ede34c4-2c7b-4de7-93a9-c2e804915cbc",
    "hitokoto": "等闲识得东风面，万紫千红总是春。",
    "type": "i",
    "from": "春日",
    "from_who": "朱熹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271520",
    "length": 16
  },
  {
    "id": 5665,
    "uuid": "ee3e0359-0234-43b8-8660-a96109fe2851",
    "hitokoto": "明月几时有？把酒问青天。",
    "type": "i",
    "from": "水调歌头·丙辰中秋",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271520",
    "length": 12
  },
  {
    "id": 5666,
    "uuid": "2045a85d-ba1b-4eb7-9cb0-1f9dc4246540",
    "hitokoto": "自是人生长恨水长东。",
    "type": "i",
    "from": "相见欢·林花谢了春红",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271520",
    "length": 10
  },
  {
    "id": 5667,
    "uuid": "95b48c62-09f6-4bd7-8637-37dacdc13e83",
    "hitokoto": "羡青山有思，白鹤忘机。",
    "type": "i",
    "from": "八声甘州·摘青梅荐酒",
    "from_who": "汤恢",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271521",
    "length": 11
  },
  {
    "id": 5668,
    "uuid": "2bac9f6a-475e-4867-881d-3490565afcbf",
    "hitokoto": "秋阴不散霜飞晚，留得枯荷听雨声。",
    "type": "i",
    "from": "宿骆氏亭寄怀崔雍崔衮",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271521",
    "length": 16
  },
  {
    "id": 5669,
    "uuid": "f4a584c8-57ad-47c5-8b51-ded82f97016d",
    "hitokoto": "嫦娥应悔偷灵药，碧海青天夜夜心。",
    "type": "i",
    "from": "嫦娥",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271521",
    "length": 16
  },
  {
    "id": 5670,
    "uuid": "8a67cb5f-e107-4f06-b4bf-7548e54f1deb",
    "hitokoto": "七八个星天外，两三点雨山前。",
    "type": "i",
    "from": "西江月·夜行黄沙道中",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271522",
    "length": 14
  },
  {
    "id": 5671,
    "uuid": "1f161335-016c-4ab5-b2d2-f13e19ca7716",
    "hitokoto": "采菊东篱下，悠然见南山。",
    "type": "i",
    "from": "饮酒·其五",
    "from_who": "陶渊明",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271522",
    "length": 12
  },
  {
    "id": 5672,
    "uuid": "8f0efbb5-6863-4e09-9b9c-5f6b1b257a8d",
    "hitokoto": "劝君更尽一杯酒，西出阳关无故人。",
    "type": "i",
    "from": "渭城曲 / 送元二使安西",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271523",
    "length": 16
  },
  {
    "id": 5673,
    "uuid": "aa6e56b1-e4d6-4044-8e52-7e582e0077c2",
    "hitokoto": "南朝四百八十寺，多少楼台烟雨中。",
    "type": "i",
    "from": "江南春",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271523",
    "length": 16
  },
  {
    "id": 5674,
    "uuid": "b5c3fba1-4218-4eef-be2d-2a1623182161",
    "hitokoto": "南风知我意，吹梦到西洲。",
    "type": "i",
    "from": "西洲曲",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271523",
    "length": 12
  },
  {
    "id": 5675,
    "uuid": "10e3a121-39d2-4516-b241-e1c1a0173139",
    "hitokoto": "人生亦有命，安能行叹复坐愁？",
    "type": "i",
    "from": "拟行路难·其四",
    "from_who": "鲍照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271524",
    "length": 14
  },
  {
    "id": 5676,
    "uuid": "4608e405-4bd2-40f1-b374-0eb7f7632385",
    "hitokoto": "当时明月在，曾照彩云归。",
    "type": "i",
    "from": "临江仙·梦后楼台高锁",
    "from_who": "晏几道",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271524",
    "length": 12
  },
  {
    "id": 5677,
    "uuid": "b2b6918f-32ff-4d1c-a291-f3112668ad0e",
    "hitokoto": "三十功名尘与土，八千里路云和月。",
    "type": "i",
    "from": "满江红·写怀",
    "from_who": "岳飞",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271524",
    "length": 16
  },
  {
    "id": 5678,
    "uuid": "1848816a-ddb6-4d5d-b57d-3bd6daac606c",
    "hitokoto": "沧海月明珠有泪，蓝田日暖玉生烟。",
    "type": "i",
    "from": "锦瑟",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271525",
    "length": 16
  },
  {
    "id": 5679,
    "uuid": "e3497578-17a0-498c-a711-30d1e53804b8",
    "hitokoto": "井蛙不可以语于海者，拘于虚也；夏虫不可以语于冰者，笃于时也",
    "type": "i",
    "from": "庄子·外篇·秋水",
    "from_who": "庄子休",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271525",
    "length": 29
  },
  {
    "id": 5680,
    "uuid": "ec0238ec-351c-41e0-bcf4-b568d904bc86",
    "hitokoto": "出师未捷身先死，长使英雄泪满襟。",
    "type": "i",
    "from": "蜀相",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271525",
    "length": 16
  },
  {
    "id": 5681,
    "uuid": "a2a766a0-ed4a-4d91-a088-0643d88a8a6d",
    "hitokoto": "近乡情更怯，不敢问来人。",
    "type": "i",
    "from": "渡汉江",
    "from_who": "宋之问",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271526",
    "length": 12
  },
  {
    "id": 5682,
    "uuid": "3d794054-9b3e-4e99-be66-889188d7c192",
    "hitokoto": "星垂平野阔，月涌大江流。",
    "type": "i",
    "from": "旅夜书怀",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271526",
    "length": 12
  },
  {
    "id": 5683,
    "uuid": "f216d82b-52cb-4737-9f28-7122b45d033d",
    "hitokoto": "朔风如解意，容易莫摧残。",
    "type": "i",
    "from": "梅花",
    "from_who": "崔道融",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271526",
    "length": 12
  },
  {
    "id": 5684,
    "uuid": "25ff2fde-8f8b-4714-b7c9-7ac4fc154589",
    "hitokoto": "黑发不知勤学早，白首方悔读书迟。",
    "type": "i",
    "from": "劝学诗",
    "from_who": "颜真卿",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271527",
    "length": 16
  },
  {
    "id": 5685,
    "uuid": "c96a0d32-ac23-4cb7-95c7-6abb2f892a01",
    "hitokoto": "春水碧于天，画船听雨眠。",
    "type": "i",
    "from": "菩萨蛮·人人尽说江南好",
    "from_who": "韦庄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271528",
    "length": 12
  },
  {
    "id": 5686,
    "uuid": "46d64388-66f1-407e-a78f-f333bc7091fd",
    "hitokoto": "一道残阳铺水中，半江瑟瑟半江红。",
    "type": "i",
    "from": "暮江吟",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271528",
    "length": 16
  },
  {
    "id": 5687,
    "uuid": "1024613d-2ad7-4ef2-abc1-2a9dec14585a",
    "hitokoto": "无情不似多情苦。一寸还成千万缕。",
    "type": "i",
    "from": "玉楼春·春恨",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271529",
    "length": 16
  },
  {
    "id": 5688,
    "uuid": "2d7a549e-5ace-42fc-ad1f-720551956279",
    "hitokoto": "盛年不重来，一日难再晨。",
    "type": "i",
    "from": "杂诗·人生无根蒂",
    "from_who": "陶渊明",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271530",
    "length": 12
  },
  {
    "id": 5689,
    "uuid": "5e80749f-3c75-46ef-94b3-1e5fc4c5869d",
    "hitokoto": "此情无计可消除，才下眉头，却上心头。",
    "type": "i",
    "from": "一剪梅·红藕香残玉簟秋",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271530",
    "length": 18
  },
  {
    "id": 5690,
    "uuid": "0d0542f4-8112-4d1a-9c27-1ccb28235f85",
    "hitokoto": "君问归期未有期，巴山夜雨涨秋池。",
    "type": "i",
    "from": "夜雨寄北",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271531",
    "length": 16
  },
  {
    "id": 5691,
    "uuid": "9759b119-6caa-4666-9020-7e0ae6495d07",
    "hitokoto": "以色事他人，能得几时好。",
    "type": "i",
    "from": "妾薄命",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271531",
    "length": 12
  },
  {
    "id": 5692,
    "uuid": "877be8c6-f8cd-423d-b360-8a383251c7bb",
    "hitokoto": "我住长江头，君住长江尾。",
    "type": "i",
    "from": "卜算子·我住长江头",
    "from_who": "李之仪",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271532",
    "length": 12
  },
  {
    "id": 5693,
    "uuid": "9075e9b6-da61-48d9-8810-7871f08b9274",
    "hitokoto": "关关雎鸠，在河之洲。窈窕淑女，君子好逑。",
    "type": "i",
    "from": "关雎",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271532",
    "length": 20
  },
  {
    "id": 5694,
    "uuid": "ad896286-cf93-419a-9cd6-469cad5c496e",
    "hitokoto": "满目山河空念远，落花风雨更伤春。",
    "type": "i",
    "from": "浣溪沙·一向年光有限身",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271533",
    "length": 16
  },
  {
    "id": 5695,
    "uuid": "9d6aac27-09cc-4a89-8db5-252b39f19cc9",
    "hitokoto": "草木有本心，何求美人折！",
    "type": "i",
    "from": "感遇十二首·其一",
    "from_who": "张九龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271533",
    "length": 12
  },
  {
    "id": 5696,
    "uuid": "9e634b24-8087-4e29-a9b3-8fc5f4a1c567",
    "hitokoto": "会当凌绝顶，一览众山小。",
    "type": "i",
    "from": "望岳",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271533",
    "length": 12
  },
  {
    "id": 5697,
    "uuid": "642db1fc-4dc8-4303-b762-563d5a061cf6",
    "hitokoto": "绿杨烟外晓寒轻，红杏枝头春意闹。",
    "type": "i",
    "from": "玉楼春·春景",
    "from_who": "宋祁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271534",
    "length": 16
  },
  {
    "id": 5698,
    "uuid": "9a66cd4d-5a16-4aee-8ee1-32610978905e",
    "hitokoto": "海内存知己，天涯若比邻。",
    "type": "i",
    "from": "送杜少府之任蜀州 / 送杜少府之任蜀川",
    "from_who": "王勃",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271534",
    "length": 12
  },
  {
    "id": 5699,
    "uuid": "4d90cc52-3aca-4461-9772-5c23bda221f9",
    "hitokoto": "但愿人长久，千里共婵娟。",
    "type": "i",
    "from": "水调歌头·丙辰中秋",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271534",
    "length": 12
  },
  {
    "id": 5700,
    "uuid": "ef37fb8e-8228-4d19-b561-6cc62014b52e",
    "hitokoto": "人生到处知何似，应似飞鸿踏雪泥。",
    "type": "i",
    "from": "和子由渑池怀旧",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271535",
    "length": 16
  },
  {
    "id": 5701,
    "uuid": "16e18962-9d36-4028-a168-84914c845f25",
    "hitokoto": "水晶帘动微风起，满架蔷薇一院香。",
    "type": "i",
    "from": "山亭夏日",
    "from_who": "高骈",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271535",
    "length": 16
  },
  {
    "id": 5702,
    "uuid": "553d8445-f4bd-4dbf-a3c8-a85f4d61821c",
    "hitokoto": "欲寄彩笺兼尺素，山长水阔知何处。",
    "type": "i",
    "from": "蝶恋花·槛菊愁烟兰泣露",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271535",
    "length": 16
  },
  {
    "id": 5703,
    "uuid": "6ee66a84-6559-4dd2-a467-4ff9676172ce",
    "hitokoto": "绿蚁新醅酒，红泥小火炉。",
    "type": "i",
    "from": "问刘十九",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271536",
    "length": 12
  },
  {
    "id": 5704,
    "uuid": "80a3bb77-8ff7-4429-b38b-5a1166a7165f",
    "hitokoto": "天生我材必有用，千金散尽还复来。",
    "type": "i",
    "from": "将进酒",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586271536",
    "length": 16
  },
  {
    "id": 5705,
    "uuid": "a326411e-882a-4162-8db1-b1ae16c51ebb",
    "hitokoto": "劝君莫惜花前醉，今年花谢，明年花谢，白了人头。",
    "type": "i",
    "from": "青杏儿·风雨替花愁",
    "from_who": "赵秉文",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333483",
    "length": 23
  },
  {
    "id": 5706,
    "uuid": "eab0b49a-af9a-475a-ab73-85741d987c83",
    "hitokoto": "兰陵美酒郁金香，玉碗盛来琥珀光。",
    "type": "i",
    "from": "客中行 / 客中作",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333484",
    "length": 16
  },
  {
    "id": 5707,
    "uuid": "ea6a73ce-4a83-4ff8-b749-9657b48d5d9b",
    "hitokoto": "故人西辞黄鹤楼，烟花三月下扬州。",
    "type": "i",
    "from": "黄鹤楼送孟浩然之广陵",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333484",
    "length": 16
  },
  {
    "id": 5708,
    "uuid": "255dda12-df94-4bdd-badb-2556d0b9084f",
    "hitokoto": "往者不可谏，来者犹可追。",
    "type": "i",
    "from": "论语·微子篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333485",
    "length": 12
  },
  {
    "id": 5709,
    "uuid": "c75e49e1-8f48-4a40-b2f6-fe9fbeaa74d5",
    "hitokoto": "相思了无益，悔当初相见。",
    "type": "i",
    "from": "忆少年·飞花时节",
    "from_who": "朱彝尊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333485",
    "length": 12
  },
  {
    "id": 5710,
    "uuid": "a7756316-39a2-4426-b5fd-88699d9e99f5",
    "hitokoto": "水光潋滟晴方好，山色空蒙雨亦奇。",
    "type": "i",
    "from": "饮湖上初晴后雨二首·其二",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333485",
    "length": 16
  },
  {
    "id": 5711,
    "uuid": "bbc721b8-9027-4814-87cf-92e0c3c73274",
    "hitokoto": "葡萄美酒夜光杯，欲饮琵琶马上催。",
    "type": "i",
    "from": "凉州词二首·其一",
    "from_who": "王翰",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333486",
    "length": 16
  },
  {
    "id": 5712,
    "uuid": "d188a075-9e0a-4bb9-8303-992335e23d46",
    "hitokoto": "借问江潮与海水，何似君情与妾心？",
    "type": "i",
    "from": "浪淘沙·借问江潮与海水",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333486",
    "length": 16
  },
  {
    "id": 5713,
    "uuid": "df2bfc8e-f72d-47d0-9ac8-07e425e89600",
    "hitokoto": "明月松间照，清泉石上流。",
    "type": "i",
    "from": "山居秋暝",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333486",
    "length": 12
  },
  {
    "id": 5714,
    "uuid": "7da20882-9843-42b8-92e9-cc3915f818cd",
    "hitokoto": "接天莲叶无穷碧，映日荷花别样红。",
    "type": "i",
    "from": "晓出净慈寺送林子方",
    "from_who": "杨万里",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333487",
    "length": 16
  },
  {
    "id": 5715,
    "uuid": "53e8e521-6449-40c4-aa89-a62933fbfcfd",
    "hitokoto": "君知妾有夫，赠妾双明珠。",
    "type": "i",
    "from": "节妇吟·寄东平李司空师道",
    "from_who": "张籍",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333487",
    "length": 12
  },
  {
    "id": 5716,
    "uuid": "71396790-6d06-49dd-bc72-2568311cdd7b",
    "hitokoto": "粗缯大布裹生涯，腹有诗书气自华。",
    "type": "i",
    "from": "和董传留别",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333487",
    "length": 16
  },
  {
    "id": 5717,
    "uuid": "106fa96a-49c4-454b-b87e-53a456e6a436",
    "hitokoto": "墙外行人，墙里佳人笑。",
    "type": "i",
    "from": "蝶恋花·春景",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333488",
    "length": 11
  },
  {
    "id": 5718,
    "uuid": "eead8729-2e5b-466a-a223-1ce0fbf2b863",
    "hitokoto": "水是眼波横，山是眉峰聚。",
    "type": "i",
    "from": "卜算子·送鲍浩然之浙东",
    "from_who": "王观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333488",
    "length": 12
  },
  {
    "id": 5719,
    "uuid": "1a73ea58-1cc6-475b-8aa3-5de021b69eb8",
    "hitokoto": "柳庭风静人眠昼，昼眠人静风庭柳。",
    "type": "i",
    "from": "菩萨蛮·回文夏闺怨",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333488",
    "length": 16
  },
  {
    "id": 5720,
    "uuid": "9ada4b21-e66f-49ad-9a08-cf7f584e7e2d",
    "hitokoto": "人生自古谁无死？留取丹心照汗青。",
    "type": "i",
    "from": "过零丁洋",
    "from_who": "文天祥",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333489",
    "length": 16
  },
  {
    "id": 5721,
    "uuid": "9ba2bd2d-9c7d-40b3-9bab-4162039b179c",
    "hitokoto": "知否，知否？应是绿肥红瘦。",
    "type": "i",
    "from": "如梦令·昨夜雨疏风骤",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333489",
    "length": 13
  },
  {
    "id": 5722,
    "uuid": "6b5e599c-a1d7-4010-bca2-d3717923ffd1",
    "hitokoto": "柴门闻犬吠，风雪夜归人。",
    "type": "i",
    "from": "逢雪宿芙蓉山主人",
    "from_who": "刘长卿",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333489",
    "length": 12
  },
  {
    "id": 5723,
    "uuid": "ff7fa1ad-5bba-4ee9-b86f-443129a88528",
    "hitokoto": "缺月挂疏桐，漏断人初静。",
    "type": "i",
    "from": "卜算子·黄州定慧院寓居作",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333490",
    "length": 12
  },
  {
    "id": 5724,
    "uuid": "57c12842-474d-406a-a424-8523d2737bec",
    "hitokoto": "忽见陌头杨柳色，悔教夫婿觅封侯。",
    "type": "i",
    "from": "闺怨",
    "from_who": "王昌龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333490",
    "length": 16
  },
  {
    "id": 5725,
    "uuid": "5b4bc83c-aaa4-496b-be3a-bef01d0e43ce",
    "hitokoto": "窈窕淑女，君子好逑。",
    "type": "i",
    "from": "关雎",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333490",
    "length": 10
  },
  {
    "id": 5726,
    "uuid": "0b932ad4-33ae-4c48-b697-43b98624838b",
    "hitokoto": "商女不知亡国恨，隔江犹唱后庭花。",
    "type": "i",
    "from": "泊秦淮",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333491",
    "length": 16
  },
  {
    "id": 5727,
    "uuid": "960f7df3-ae11-413f-9a9a-ce1d47345d1e",
    "hitokoto": "相逢一醉是前缘，风雨散、飘然何处。",
    "type": "i",
    "from": "鹊桥仙·七夕",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333491",
    "length": 17
  },
  {
    "id": 5728,
    "uuid": "fea29eee-11a5-4d5b-8ae4-e0702ad2cbef",
    "hitokoto": "此生谁料，心在天山，身老沧洲。",
    "type": "i",
    "from": "诉衷情·当年万里觅封侯",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333492",
    "length": 15
  },
  {
    "id": 5729,
    "uuid": "d694cca5-9fda-46b3-881b-521f1ea0afde",
    "hitokoto": "羌笛何须怨杨柳，春风不度玉门关。",
    "type": "i",
    "from": "凉州词二首·其一",
    "from_who": "王之涣",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333492",
    "length": 16
  },
  {
    "id": 5730,
    "uuid": "98686a97-dfbc-43b4-ad77-c15dffc8873e",
    "hitokoto": "今夜月明人尽望，不知秋思落谁家。",
    "type": "i",
    "from": "十五夜望月寄杜郎中",
    "from_who": "王建",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333493",
    "length": 16
  },
  {
    "id": 5731,
    "uuid": "93abee05-d843-47cd-893a-47f4b22740bf",
    "hitokoto": "春潮带雨晚来急，野渡无人舟自横。",
    "type": "i",
    "from": "滁州西涧",
    "from_who": "韦应物",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333493",
    "length": 16
  },
  {
    "id": 5732,
    "uuid": "7683fb4f-fe3d-413d-bf3a-f8b903f0faa8",
    "hitokoto": "萧萧梧叶送寒声，江上秋风动客情。",
    "type": "i",
    "from": "夜书所见",
    "from_who": "叶绍翁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333493",
    "length": 16
  },
  {
    "id": 5733,
    "uuid": "c740188b-4b6a-4a78-b0e7-5db72b481280",
    "hitokoto": "昭昭若日月之明，离离如星辰之行",
    "type": "i",
    "from": "文心雕龙·宗经",
    "from_who": "刘勰",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333494",
    "length": 15
  },
  {
    "id": 5734,
    "uuid": "f3a42355-25f4-4ba9-a626-efe0ad5a3585",
    "hitokoto": "相恨不如潮有信，相思始觉海非深。",
    "type": "i",
    "from": "浪淘沙·借问江潮与海水",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333494",
    "length": 16
  },
  {
    "id": 5735,
    "uuid": "dabe4a0e-fa27-4476-b026-1bd4dd8f7ee4",
    "hitokoto": "草长莺飞二月天，拂堤杨柳醉春烟。",
    "type": "i",
    "from": "村居",
    "from_who": "高鼎",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333494",
    "length": 16
  },
  {
    "id": 5736,
    "uuid": "df4b3030-50d8-4005-88ad-4eb034a68cc0",
    "hitokoto": "两个黄鹂鸣翠柳，一行白鹭上青天。",
    "type": "i",
    "from": "绝句",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333495",
    "length": 16
  },
  {
    "id": 5737,
    "uuid": "5f29e587-39e8-4011-8f41-530908f35fc0",
    "hitokoto": "枕上诗书闲处好，门前风景雨来佳。",
    "type": "i",
    "from": "摊破浣溪沙·病起萧萧两鬓华",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333495",
    "length": 16
  },
  {
    "id": 5738,
    "uuid": "4ec1e9df-6baa-4a7d-908c-4e217d0bc15d",
    "hitokoto": "迟日江山丽，春风花草香。",
    "type": "i",
    "from": "绝句二首",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333495",
    "length": 12
  },
  {
    "id": 5739,
    "uuid": "ab97432f-b7e0-4304-a10a-43706b038f25",
    "hitokoto": "自古逢秋悲寂寥，我言秋日胜春朝。",
    "type": "i",
    "from": "秋词",
    "from_who": "刘禹锡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333496",
    "length": 16
  },
  {
    "id": 5740,
    "uuid": "954df3c2-64a9-4754-bfad-3df42eb28c11",
    "hitokoto": "墙角数枝梅，凌寒独自开。",
    "type": "i",
    "from": "梅花 / 梅",
    "from_who": "王安石",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333496",
    "length": 12
  },
  {
    "id": 5741,
    "uuid": "bae451f2-cd6b-4175-82bc-b412951e72e2",
    "hitokoto": "妆罢低声问夫婿，画眉深浅入时无。",
    "type": "i",
    "from": "近试上张籍水部 / 近试上张水部 / 闺意献张水部",
    "from_who": "朱庆馀",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333496",
    "length": 16
  },
  {
    "id": 5742,
    "uuid": "81621c24-c834-4b00-b7e2-bef7d45ca8d6",
    "hitokoto": "从前种种，譬如昨日死；从后种种，譬如今日生",
    "type": "i",
    "from": "了凡四训·立命之学",
    "from_who": "袁了凡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333497",
    "length": 21
  },
  {
    "id": 5743,
    "uuid": "ae5abbb7-0c04-437a-8f41-0cc4b88221cb",
    "hitokoto": "以人言善我，必以人言罪我。",
    "type": "i",
    "from": "韩非子·说林上",
    "from_who": "韩非",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586333497",
    "length": 13
  },
  {
    "id": 5744,
    "uuid": "c3602154-62fa-431e-97a9-5faa0776f385",
    "hitokoto": "千山鸟飞绝，万径人踪灭。",
    "type": "i",
    "from": "江雪",
    "from_who": "柳宗元",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395373",
    "length": 12
  },
  {
    "id": 5745,
    "uuid": "c93c965c-7de4-4611-b574-a2e1344d5bd5",
    "hitokoto": "江畔何人初见月？江月何年初照人？",
    "type": "i",
    "from": "春江花月夜",
    "from_who": "张若虚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395374",
    "length": 16
  },
  {
    "id": 5746,
    "uuid": "0e36fe28-11e1-43e1-8c5b-513c99514601",
    "hitokoto": "若待上林花似锦，出门俱是看花人。",
    "type": "i",
    "from": "城东早春",
    "from_who": "杨巨源",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395374",
    "length": 16
  },
  {
    "id": 5747,
    "uuid": "42824419-9946-48eb-a892-3c6ee4b5c5c4",
    "hitokoto": "古人学问无遗力，少壮工夫老始成。",
    "type": "i",
    "from": "冬夜读书示子聿",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395374",
    "length": 16
  },
  {
    "id": 5748,
    "uuid": "1c417955-99a6-405a-b696-f58e8985465d",
    "hitokoto": "风一更，雪一更，聒碎乡心梦不成，故园无此声。",
    "type": "i",
    "from": "长相思·山一程",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395375",
    "length": 22
  },
  {
    "id": 5749,
    "uuid": "cad98c27-400a-4bd4-8a37-2c05a09012b5",
    "hitokoto": "莫道不销魂，帘卷西风，人比黄花瘦。",
    "type": "i",
    "from": "醉花阴·薄雾浓云愁永昼",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395375",
    "length": 17
  },
  {
    "id": 5750,
    "uuid": "cb5f9471-155c-4324-928a-0b4ef9e2b038",
    "hitokoto": "造物无言却有情，每于寒尽觉春生。",
    "type": "i",
    "from": "新雷",
    "from_who": "张维屏",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395376",
    "length": 16
  },
  {
    "id": 5751,
    "uuid": "f7b0dd64-6cc1-42d2-bb4e-a9636fd45a63",
    "hitokoto": "风乍起，吹皱一池春水。",
    "type": "i",
    "from": "谒金门·风乍起",
    "from_who": "冯延巳",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395376",
    "length": 11
  },
  {
    "id": 5752,
    "uuid": "be7cb8ce-140a-4c5d-9a6f-f36026d558fb",
    "hitokoto": "山不在高，有仙则名。水不在深，有龙则灵。",
    "type": "i",
    "from": "陋室铭",
    "from_who": "刘禹锡",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395376",
    "length": 20
  },
  {
    "id": 5753,
    "uuid": "d1f594d6-5d2f-4908-a6e7-c2a97e870a7c",
    "hitokoto": "身既死兮神以灵，魂魄毅兮为鬼雄。",
    "type": "i",
    "from": "国殇",
    "from_who": "屈原",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395377",
    "length": 16
  },
  {
    "id": 5754,
    "uuid": "76324aa4-2c06-4e7a-8945-2baade932230",
    "hitokoto": "毕竟西湖六月中，风光不与四时同。",
    "type": "i",
    "from": "晓出净慈寺送林子方",
    "from_who": "杨万里",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395377",
    "length": 16
  },
  {
    "id": 5755,
    "uuid": "2a9a7757-aa6d-436d-a948-29901ae5a180",
    "hitokoto": "我也不登天子船，我也不上长安眠。",
    "type": "i",
    "from": "把酒对月歌",
    "from_who": "唐寅",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395377",
    "length": 16
  },
  {
    "id": 5756,
    "uuid": "e599af50-29bb-4b48-b2c1-76f94d97ae19",
    "hitokoto": "大漠沙如雪，燕山月似钩。",
    "type": "i",
    "from": "马诗二十三首·其五",
    "from_who": "李贺",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395378",
    "length": 12
  },
  {
    "id": 5757,
    "uuid": "36b2309e-e00b-4ffc-a32e-a1779d661dc5",
    "hitokoto": "泉涸，鱼相与处于陆，相呴以湿，相濡以沫，不如相忘于江湖。",
    "type": "i",
    "from": "庄子·内篇·大宗师",
    "from_who": "周子休",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395378",
    "length": 28
  },
  {
    "id": 5758,
    "uuid": "5cdb5464-6a77-49b4-9d07-39fca7eb54bf",
    "hitokoto": "日色欲尽花含烟，月明欲素愁不眠。",
    "type": "i",
    "from": "长相思·其二",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395378",
    "length": 16
  },
  {
    "id": 5759,
    "uuid": "9cc54e14-7fd1-4d84-ad9e-f18fb69300c7",
    "hitokoto": "三更灯火五更鸡，正是男儿读书时。",
    "type": "i",
    "from": "劝学诗",
    "from_who": "颜真卿",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395379",
    "length": 16
  },
  {
    "id": 5760,
    "uuid": "273f83d9-367f-47c5-abc5-22253745e71b",
    "hitokoto": "江南几度梅花发，人在天涯鬓已斑。",
    "type": "i",
    "from": "鹧鸪天·雪照山城玉指寒",
    "from_who": "刘著",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395379",
    "length": 16
  },
  {
    "id": 5761,
    "uuid": "e3854f83-cfb2-496f-803e-873981c4e699",
    "hitokoto": "松树千年终是朽，槿花一日自为荣。",
    "type": "i",
    "from": "放言五首·其五",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395379",
    "length": 16
  },
  {
    "id": 5762,
    "uuid": "1c0a0b54-d1fc-4087-b2b7-8e0ea5a33c07",
    "hitokoto": "桃李不言，下自成蹊。",
    "type": "i",
    "from": "史记·李将军列传",
    "from_who": "司马迁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395380",
    "length": 10
  },
  {
    "id": 5763,
    "uuid": "44c15ee6-2dd4-4fc4-8a1e-63d6864f3069",
    "hitokoto": "连雨不知春去，一晴方觉夏深。",
    "type": "i",
    "from": "喜晴",
    "from_who": "范成大",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395380",
    "length": 14
  },
  {
    "id": 5764,
    "uuid": "e6c77da4-4fcd-40c1-8419-6cb46fa294f0",
    "hitokoto": "易求无价宝，难得有心郎。",
    "type": "i",
    "from": "赠邻女 / 寄李亿员外",
    "from_who": "鱼玄机",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395387",
    "length": 12
  },
  {
    "id": 5765,
    "uuid": "0e2cca51-cb26-46cb-b961-a936de07c6d1",
    "hitokoto": "有情芍药含春泪，无力蔷薇卧晓枝。",
    "type": "i",
    "from": "春日",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395387",
    "length": 16
  },
  {
    "id": 5766,
    "uuid": "71f89824-3775-4bf6-afb1-203d0bf6305d",
    "hitokoto": "执手相看泪眼，竟无语凝噎。",
    "type": "i",
    "from": "雨霖铃·寒蝉凄切",
    "from_who": "柳永",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395387",
    "length": 13
  },
  {
    "id": 5767,
    "uuid": "e2565946-c686-4133-8580-9076e34a73b7",
    "hitokoto": "日暮苍山远，天寒白屋贫。",
    "type": "i",
    "from": "逢雪宿芙蓉山主人",
    "from_who": "刘长卿",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395388",
    "length": 12
  },
  {
    "id": 5768,
    "uuid": "568ae486-469c-4cf2-b7b9-d2fd3cd6e0a0",
    "hitokoto": "山远天高烟水寒，相思枫叶丹。",
    "type": "i",
    "from": "长相思·一重山",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395388",
    "length": 14
  },
  {
    "id": 5769,
    "uuid": "8b10bb52-d38b-4f1d-8522-52dd8bcb8b3e",
    "hitokoto": "浮生只合尊前老。雪满长安道。",
    "type": "i",
    "from": "虞美人·寄公度",
    "from_who": "舒亶",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395388",
    "length": 14
  },
  {
    "id": 5770,
    "uuid": "24888d87-0f2a-4811-8c88-d6673ea82671",
    "hitokoto": "及时当勉励，岁月不待人。",
    "type": "i",
    "from": "杂诗·人生无根蒂",
    "from_who": "陶渊明",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395389",
    "length": 12
  },
  {
    "id": 5771,
    "uuid": "3b052170-8dd0-4cbe-bbe8-be7e4b7727b3",
    "hitokoto": "慈母手中线，游子身上衣。",
    "type": "i",
    "from": "游子吟 / 迎母漂上作",
    "from_who": "孟郊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395389",
    "length": 12
  },
  {
    "id": 5772,
    "uuid": "0eb3e577-949a-4d90-8f65-7477b9417862",
    "hitokoto": "天阶夜色凉如水，卧看牵牛织女星。",
    "type": "i",
    "from": "秋夕",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395389",
    "length": 16
  },
  {
    "id": 5773,
    "uuid": "c89d5ae3-efba-46de-9435-b14c61cc6066",
    "hitokoto": "花褪残红青杏小。燕子飞时，绿水人家绕。",
    "type": "i",
    "from": "蝶恋花·春景",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395389",
    "length": 19
  },
  {
    "id": 5774,
    "uuid": "7ae40fb7-2a7d-43e4-9005-9dc1af242e99",
    "hitokoto": "中秋谁与共孤光。把盏凄然北望。",
    "type": "i",
    "from": "西江月·世事一场大梦",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395390",
    "length": 15
  },
  {
    "id": 5775,
    "uuid": "0951d929-14ca-4d6e-a263-25d5df2f49c3",
    "hitokoto": "孤舟蓑笠翁，独钓寒江雪。",
    "type": "i",
    "from": "江雪",
    "from_who": "柳宗元",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395390",
    "length": 12
  },
  {
    "id": 5776,
    "uuid": "71849835-81c7-45df-b09a-d92be71559e8",
    "hitokoto": "博观而约取，厚积而薄发",
    "type": "i",
    "from": "稼说送张琥",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395390",
    "length": 11
  },
  {
    "id": 5777,
    "uuid": "2284b10d-8718-463c-9dc1-98f3d7b8082d",
    "hitokoto": "七夕今宵看碧霄，牵牛织女渡河桥。",
    "type": "i",
    "from": "乞巧",
    "from_who": "林杰",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395391",
    "length": 16
  },
  {
    "id": 5778,
    "uuid": "0ece3830-bcd2-4be0-82d4-4a4586fc7cd1",
    "hitokoto": "宁不知倾城与倾国。佳人难再得。",
    "type": "i",
    "from": "李延年歌",
    "from_who": "李延年",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395391",
    "length": 15
  },
  {
    "id": 5779,
    "uuid": "d9846803-f960-43f9-8471-7a4837f25611",
    "hitokoto": "多情却被无情恼，今夜还如昨夜长。",
    "type": "i",
    "from": "鹧鸪天·候馆灯昏雨送凉",
    "from_who": "元好问",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395391",
    "length": 16
  },
  {
    "id": 5780,
    "uuid": "a42043a2-03c2-4e1a-8af4-0406c8c118de",
    "hitokoto": "庭前落尽梧桐，水边开彻芙蓉。",
    "type": "i",
    "from": "天净沙·秋",
    "from_who": "朱庭玉",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395392",
    "length": 14
  },
  {
    "id": 5781,
    "uuid": "560c196e-f668-4431-91eb-0f9058c79915",
    "hitokoto": "离离原上草，一岁一枯荣。",
    "type": "i",
    "from": "草 / 赋得古原草送别",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395392",
    "length": 12
  },
  {
    "id": 5782,
    "uuid": "7a0505d5-5ad7-4c7d-a7d9-53bc5573fe10",
    "hitokoto": "冰雪林中著此身，不同桃李混芳尘；",
    "type": "i",
    "from": "白梅",
    "from_who": "王冕",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395392",
    "length": 16
  },
  {
    "id": 5783,
    "uuid": "a039cd1c-90a8-40ba-b2c6-432a1e9b63dc",
    "hitokoto": "秋风起兮白云飞，草木黄落兮雁南归。",
    "type": "i",
    "from": "秋风辞",
    "from_who": "刘彻",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395393",
    "length": 17
  },
  {
    "id": 5784,
    "uuid": "fb25cd75-40a4-4e9e-816a-54cd2e1cbb24",
    "hitokoto": "宁为百夫长，胜作一书生。",
    "type": "i",
    "from": "从军行",
    "from_who": "杨炯",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395481",
    "length": 12
  },
  {
    "id": 5785,
    "uuid": "2eb4511c-017b-491f-81e5-b3a653781cf9",
    "hitokoto": "无言独上西楼，月如钩。寂寞梧桐深院锁清秋。",
    "type": "i",
    "from": "相见欢·无言独上西楼",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395481",
    "length": 21
  },
  {
    "id": 5786,
    "uuid": "e24523d3-14bd-454a-ba05-f352e17b04a8",
    "hitokoto": "西塞山前白鹭飞，桃花流水鳜鱼肥。",
    "type": "i",
    "from": "渔歌子·西塞山前白鹭飞",
    "from_who": "张志和",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395481",
    "length": 16
  },
  {
    "id": 5787,
    "uuid": "b0d30706-9bb9-4841-913e-36ef87b251b7",
    "hitokoto": "好雨知时节，当春乃发生。",
    "type": "i",
    "from": "春夜喜雨",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395482",
    "length": 12
  },
  {
    "id": 5788,
    "uuid": "1034b495-b7fc-4561-a97b-f7d6b81e4ee0",
    "hitokoto": "青山绿水，白草红叶黄花。",
    "type": "i",
    "from": "天净沙·秋",
    "from_who": "白朴",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395482",
    "length": 12
  },
  {
    "id": 5789,
    "uuid": "94413206-c662-4e1b-a18c-f903b622e131",
    "hitokoto": "情人怨遥夜，竟夕起相思。",
    "type": "i",
    "from": "望月怀远",
    "from_who": "张九龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395482",
    "length": 12
  },
  {
    "id": 5790,
    "uuid": "82ea61f5-2698-4e2a-9da5-b4b8a6e5b1e9",
    "hitokoto": "祸不妄至，福不徒来。",
    "type": "i",
    "from": "史记·龟策列传",
    "from_who": "司马迁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395483",
    "length": 10
  },
  {
    "id": 5791,
    "uuid": "f0eaf8f2-b1dc-4a32-9219-ed9aeddd0d5b",
    "hitokoto": "稻花香里说丰年。听取蛙声一片。",
    "type": "i",
    "from": "西江月·夜行黄沙道中",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395483",
    "length": 15
  },
  {
    "id": 5792,
    "uuid": "4f1d847b-cef1-4d08-bd68-f76ef985c070",
    "hitokoto": "平生不下泪，于此泣无穷。",
    "type": "i",
    "from": "江夏别宋之悌",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395483",
    "length": 12
  },
  {
    "id": 5793,
    "uuid": "6f3db277-ad71-49e5-9ab6-317e35bb3f22",
    "hitokoto": "伯牙鼓琴，志在高山",
    "type": "i",
    "from": "伯牙绝弦",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395484",
    "length": 9
  },
  {
    "id": 5794,
    "uuid": "cc2d5006-10ff-4c30-a71f-82558c2a14fc",
    "hitokoto": "青鸟不传云外信，丁香空结雨中愁。",
    "type": "i",
    "from": "摊破浣溪沙·手卷真珠上玉钩",
    "from_who": "李璟",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395484",
    "length": 16
  },
  {
    "id": 5795,
    "uuid": "dc4bbf94-7bf8-471d-a699-881641124eaf",
    "hitokoto": "江山代有才人出，各领风骚数百年。",
    "type": "i",
    "from": "论诗五首·其二",
    "from_who": "赵翼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395484",
    "length": 16
  },
  {
    "id": 5796,
    "uuid": "1667271c-3eec-43f0-bc72-38d68a2d6c6e",
    "hitokoto": "新竹高于旧竹枝，全凭老干为扶持。",
    "type": "i",
    "from": "新竹",
    "from_who": "郑燮",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395485",
    "length": 16
  },
  {
    "id": 5797,
    "uuid": "d12e1642-746a-4381-88ab-0758ce7288b2",
    "hitokoto": "野旷天低树，江清月近人。",
    "type": "i",
    "from": "宿建德江",
    "from_who": "孟浩然",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395485",
    "length": 12
  },
  {
    "id": 5798,
    "uuid": "5c0de7d0-f871-469f-b1c6-eec3aaa51113",
    "hitokoto": "鸟宿池边树，僧敲月下门。",
    "type": "i",
    "from": "题李凝幽居",
    "from_who": "贾岛",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395485",
    "length": 12
  },
  {
    "id": 5799,
    "uuid": "74703fe8-98a9-4e4d-8959-d1b60b882535",
    "hitokoto": "我居北海君南海，寄雁传书谢不能。",
    "type": "i",
    "from": "寄黄几复",
    "from_who": "黄庭坚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395486",
    "length": 16
  },
  {
    "id": 5800,
    "uuid": "84579b2b-1bfc-4a29-926a-822789e865e5",
    "hitokoto": "不茶不饭，不言不语，一味供他憔悴。",
    "type": "i",
    "from": "鹊桥仙·说盟说誓",
    "from_who": "蜀妓",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395486",
    "length": 17
  },
  {
    "id": 5801,
    "uuid": "9faaf92c-ed63-4426-9774-dbc5c0bc0801",
    "hitokoto": "乱花渐欲迷人眼，浅草才能没马蹄。",
    "type": "i",
    "from": "钱塘湖春行",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395486",
    "length": 16
  },
  {
    "id": 5802,
    "uuid": "c6a3db3f-0fa0-4af4-b954-65d0e1f73f0a",
    "hitokoto": "昆山玉碎凤凰叫，芙蓉泣露香兰笑。",
    "type": "i",
    "from": "李凭箜篌引",
    "from_who": "李贺",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395487",
    "length": 16
  },
  {
    "id": 5803,
    "uuid": "db22331d-01bf-4988-90b1-bd9201ccdc11",
    "hitokoto": "相思相望不相亲，天为谁春。",
    "type": "i",
    "from": "画堂春·一生一代一双人",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395487",
    "length": 13
  },
  {
    "id": 5804,
    "uuid": "e0c5a1a9-ac5a-446c-8e62-51f175be54a7",
    "hitokoto": "舞低杨柳楼心月，歌尽桃花扇底风。",
    "type": "i",
    "from": "鹧鸪天·彩袖殷勤捧玉钟",
    "from_who": "晏几道",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395487",
    "length": 16
  },
  {
    "id": 5805,
    "uuid": "0c744811-3a9b-4ca0-97d2-5cb9b0f56e6f",
    "hitokoto": "君子不器。",
    "type": "i",
    "from": "论语·为政篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395488",
    "length": 5
  },
  {
    "id": 5806,
    "uuid": "175a62e0-008a-4685-b956-9260244ee0cb",
    "hitokoto": "孤灯不明思欲绝，卷帷望月空长叹。",
    "type": "i",
    "from": "长相思·其一",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395488",
    "length": 16
  },
  {
    "id": 5807,
    "uuid": "4891b487-c0ce-44fd-9fd4-35e0e00bd6a3",
    "hitokoto": "举杯邀明月，对影成三人。",
    "type": "i",
    "from": "月下独酌四首·其一",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395488",
    "length": 12
  },
  {
    "id": 5808,
    "uuid": "5f12a642-4c0c-4047-bd6e-6860961cd8b6",
    "hitokoto": "八阵图名成卧龙，六韬书功在飞熊。",
    "type": "i",
    "from": "蟾宫曲·怀古",
    "from_who": "查德卿",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395488",
    "length": 16
  },
  {
    "id": 5809,
    "uuid": "b0735608-833f-4eb9-83b5-a7bb77f91a21",
    "hitokoto": "无情最是台城柳，依旧烟笼十里堤。",
    "type": "i",
    "from": "台城",
    "from_who": "韦庄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395489",
    "length": 16
  },
  {
    "id": 5810,
    "uuid": "d87d5723-1906-46bc-bb10-ac9b18e57bff",
    "hitokoto": "江流天地外，山色有无中。",
    "type": "i",
    "from": "汉江临泛 / 汉江临眺",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395489",
    "length": 12
  },
  {
    "id": 5811,
    "uuid": "d146725f-fa8b-4da4-83aa-5cfb4d623374",
    "hitokoto": "黑云翻墨未遮山，白雨跳珠乱入船。",
    "type": "i",
    "from": "六月二十七日望湖楼醉书",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395489",
    "length": 16
  },
  {
    "id": 5812,
    "uuid": "d2a1be4f-2d93-44f6-a477-33e6757af616",
    "hitokoto": "日啖荔枝三百颗，不辞长作岭南人。",
    "type": "i",
    "from": "惠州一绝",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395490",
    "length": 16
  },
  {
    "id": 5813,
    "uuid": "61c1091b-2048-4515-a7d7-0659a8aef129",
    "hitokoto": "九州生气恃风雷，万马齐喑究可哀。",
    "type": "i",
    "from": "己亥杂诗·其二百二十",
    "from_who": "龚自珍",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395490",
    "length": 16
  },
  {
    "id": 5814,
    "uuid": "2d9fd070-bd92-4c0a-b098-70e141372c92",
    "hitokoto": "流光容易把人抛，红了樱桃，绿了芭蕉。",
    "type": "i",
    "from": "一剪梅·舟过吴江",
    "from_who": "蒋捷",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395490",
    "length": 18
  },
  {
    "id": 5815,
    "uuid": "f674900b-734b-4b11-aa31-bdcf97c20232",
    "hitokoto": "功名万里外，心事一杯中。",
    "type": "i",
    "from": "送李侍御赴安西",
    "from_who": "高适",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395491",
    "length": 12
  },
  {
    "id": 5816,
    "uuid": "e1749b8a-4b1a-4e98-91b5-2e72cfd2913a",
    "hitokoto": "黄梅时节家家雨，青草池塘处处蛙。",
    "type": "i",
    "from": "约客 / 有约",
    "from_who": "赵师秀",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395491",
    "length": 16
  },
  {
    "id": 5817,
    "uuid": "6e7cc075-3fa1-42c3-b215-fdfe6cc56988",
    "hitokoto": "若似月轮终皎洁，不辞冰雪为卿热。",
    "type": "i",
    "from": "蝶恋花·辛苦最怜天上月",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395491",
    "length": 16
  },
  {
    "id": 5818,
    "uuid": "49df3f8a-63f4-4903-aa35-c8bf39dca7af",
    "hitokoto": "月儿弯弯照九州，几家欢乐几家愁。",
    "type": "i",
    "from": "月儿弯弯照九州",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395492",
    "length": 16
  },
  {
    "id": 5819,
    "uuid": "cd091bac-4dff-4f3b-b06f-c62c4f8082c3",
    "hitokoto": "南国有佳人，容华若桃李。",
    "type": "i",
    "from": "杂诗·南国有佳人",
    "from_who": "曹植",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395492",
    "length": 12
  },
  {
    "id": 5820,
    "uuid": "09fbd777-3011-4a1a-9a21-db890c5e3a6e",
    "hitokoto": "此生此夜不长好，明月明年何处看。",
    "type": "i",
    "from": "阳关曲 / 中秋月",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395492",
    "length": 16
  },
  {
    "id": 5821,
    "uuid": "c66df82e-6a16-4bf0-a689-30ee4e58f2d9",
    "hitokoto": "莫笑贱贫夸富贵，共成枯骨两何如？",
    "type": "i",
    "from": "放言五首·其四",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395493",
    "length": 16
  },
  {
    "id": 5822,
    "uuid": "caea5e47-9fe6-4cc3-9a1f-d8eaaab8c2be",
    "hitokoto": "娶妻无媒毋须恨，书中有女颜如玉。",
    "type": "i",
    "from": "劝学诗",
    "from_who": "赵恒",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395493",
    "length": 16
  },
  {
    "id": 5823,
    "uuid": "2d08f08a-c57b-4cfd-b7f1-336afd31924c",
    "hitokoto": "诚知此恨人人有，贫贱夫妻百事哀。",
    "type": "i",
    "from": "遣悲怀三首·其二",
    "from_who": "元稹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395493",
    "length": 16
  },
  {
    "id": 5824,
    "uuid": "653d1f0b-58b2-4dde-8839-8008c1706b4e",
    "hitokoto": "试玉要烧三日满，辨材须待七年期。",
    "type": "i",
    "from": "放言五首·其三",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395380",
    "length": 16
  },
  {
    "id": 5825,
    "uuid": "fc091cdb-58f9-4cfc-90d7-15fed28b1fd7",
    "hitokoto": "悠悠天宇旷，切切故乡情。",
    "type": "i",
    "from": "西江夜行",
    "from_who": "张九龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395381",
    "length": 12
  },
  {
    "id": 5826,
    "uuid": "fabacf0b-ffd4-43ae-9e53-336e05f0375a",
    "hitokoto": "海棠未雨，梨花先雪，一半春休。",
    "type": "i",
    "from": "眼儿媚·杨柳丝丝弄轻柔",
    "from_who": "王雱",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395381",
    "length": 15
  },
  {
    "id": 5827,
    "uuid": "d63947c7-133f-4b56-9b6b-a9bb5e440916",
    "hitokoto": "知我者，谓我心忧；不知我者，谓我何求。",
    "type": "i",
    "from": "诗经·国风·王风·黍离",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395381",
    "length": 19
  },
  {
    "id": 5828,
    "uuid": "461b1ef4-7597-4506-80fe-518a8fe97ab5",
    "hitokoto": "只解沙场为国死，何须马革裹尸还。",
    "type": "i",
    "from": "出塞",
    "from_who": "徐锡麟",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395382",
    "length": 16
  },
  {
    "id": 5829,
    "uuid": "d3046bbc-ee6b-4397-b3f5-535777e6a25d",
    "hitokoto": "上善若水，水善利万物而不争。",
    "type": "i",
    "from": "老子·道经·第八章",
    "from_who": "李伯阳",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395382",
    "length": 14
  },
  {
    "id": 5830,
    "uuid": "6a058b3d-8f37-40fe-98d2-f1b05b73ff4d",
    "hitokoto": "一寸柔肠情几许？薄衾孤枕，梦回人静，彻晓潇潇雨。",
    "type": "i",
    "from": "青玉案·丝槐烟柳长亭路",
    "from_who": "惠洪",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395382",
    "length": 24
  },
  {
    "id": 5831,
    "uuid": "96cc31c1-d029-427e-b07f-b0e24cb395d2",
    "hitokoto": "长恨此身非我有，何时忘却营营。",
    "type": "i",
    "from": "临江仙·夜饮东坡醒复醉",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395382",
    "length": 15
  },
  {
    "id": 5832,
    "uuid": "3bed6c1e-c239-45d8-b7b2-8d348ef6f806",
    "hitokoto": "去年花里逢君别，今日花开已一年。",
    "type": "i",
    "from": "寄李儋元锡",
    "from_who": "韦应物",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395383",
    "length": 16
  },
  {
    "id": 5833,
    "uuid": "8f9b8d5c-ba8b-4dd9-82d0-a329b2a38087",
    "hitokoto": "明月出天山，苍茫云海间。",
    "type": "i",
    "from": "关山月",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395383",
    "length": 12
  },
  {
    "id": 5834,
    "uuid": "ec343761-23a4-468d-a85b-858bda470423",
    "hitokoto": "日出江花红胜火，春来江水绿如蓝。",
    "type": "i",
    "from": "忆江南·江南好",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395384",
    "length": 16
  },
  {
    "id": 5835,
    "uuid": "8cf2cd34-4e8b-4ff5-a6c7-2f5f1b73e845",
    "hitokoto": "欲把西湖比西子，淡妆浓抹总相宜。",
    "type": "i",
    "from": "饮湖上初晴后雨二首·其二",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395384",
    "length": 16
  },
  {
    "id": 5836,
    "uuid": "db70e760-ddc3-4bf9-b9a4-98e2ee85f2af",
    "hitokoto": "想当年，金戈铁马，气吞万里如虎。",
    "type": "i",
    "from": "永遇乐·京口北固亭怀古",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395384",
    "length": 16
  },
  {
    "id": 5837,
    "uuid": "bc5b4d78-3080-4c22-8e8f-a17f960ad47a",
    "hitokoto": "小楼昨夜又东风，故国不堪回首月明中。",
    "type": "i",
    "from": "虞美人·春花秋月何时了",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395384",
    "length": 18
  },
  {
    "id": 5838,
    "uuid": "d0394f62-1f35-453f-b47c-4a5d8b77a717",
    "hitokoto": "少无适俗韵，性本爱丘山。",
    "type": "i",
    "from": "归园田居·其一",
    "from_who": "陶渊明",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395385",
    "length": 12
  },
  {
    "id": 5839,
    "uuid": "6a7e5713-e9e1-4d0a-abe2-96060918b22f",
    "hitokoto": "忽如一夜春风来，千树万树梨花开。",
    "type": "i",
    "from": "白雪歌送武判官归京",
    "from_who": "岑参",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395385",
    "length": 16
  },
  {
    "id": 5840,
    "uuid": "b44c8eef-0b6b-4afe-8f92-667d68518401",
    "hitokoto": "小舟从此逝，江海寄余生。",
    "type": "i",
    "from": "临江仙·夜饮东坡醒复醉",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395385",
    "length": 12
  },
  {
    "id": 5841,
    "uuid": "b8056790-12a2-4ee8-8d19-34930484c33e",
    "hitokoto": "青山隐隐水迢迢，秋尽江南草未凋。",
    "type": "i",
    "from": "寄扬州韩绰判官",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395386",
    "length": 16
  },
  {
    "id": 5842,
    "uuid": "388a29ed-4f22-4777-a037-d45d4fb0f087",
    "hitokoto": "一别都门三改火，天涯踏尽红尘。",
    "type": "i",
    "from": "临江仙·送钱穆父",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395386",
    "length": 15
  },
  {
    "id": 5843,
    "uuid": "f2c72e4d-d21b-41c2-b95e-d7c7a108b805",
    "hitokoto": "天平山上白云泉，云自无心水自闲。",
    "type": "i",
    "from": "白云泉",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586395386",
    "length": 16
  },
  {
    "id": 5844,
    "uuid": "222b68de-6783-4bf3-9190-32204f5bce91",
    "hitokoto": "谁家玉笛暗飞声，散入春风满洛城。",
    "type": "i",
    "from": "春夜洛城闻笛",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586333491",
    "length": 16
  },
  {
    "id": 5845,
    "uuid": "e0b36c4b-87d0-4fdc-91ff-26abfde3806c",
    "hitokoto": "一片春愁待酒浇。江上舟摇，楼上帘招。",
    "type": "i",
    "from": "一剪梅·舟过吴江",
    "from_who": "蒋捷",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398125",
    "length": 18
  },
  {
    "id": 5848,
    "uuid": "e7470aa2-0615-4a99-a722-60828b64ae21",
    "hitokoto": "不畏浮云遮望眼，只缘身在最高层。",
    "type": "i",
    "from": "登飞来峰",
    "from_who": "王安石",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398123",
    "length": 16
  },
  {
    "id": 5849,
    "uuid": "da02797c-68a7-421b-8f4f-3850262b048c",
    "hitokoto": "恨君不似江楼月，南北东西，南北东西，只有相随无别离。",
    "type": "i",
    "from": "采桑子·恨君不似江楼月",
    "from_who": "吕本中",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398124",
    "length": 26
  },
  {
    "id": 5850,
    "uuid": "cb877476-c10f-4538-9465-31c0cdbb9524",
    "hitokoto": "我寄愁心与明月，随风直到夜郎西。",
    "type": "i",
    "from": "闻王昌龄左迁龙标遥有此寄",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398124",
    "length": 16
  },
  {
    "id": 5852,
    "uuid": "a57a2393-bde5-48ff-a110-067954fe0e9e",
    "hitokoto": "黄河远上白云间，一片孤城万仞山。",
    "type": "i",
    "from": "凉州词二首·其一",
    "from_who": "王之涣",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398123",
    "length": 16
  },
  {
    "id": 5853,
    "uuid": "b9d3ca24-55d8-457b-8e37-68b35067bbf6",
    "hitokoto": "不患无位，患所以立。不患莫己知，求为可知也。",
    "type": "i",
    "from": "论语·里仁篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398123",
    "length": 22
  },
  {
    "id": 5854,
    "uuid": "520edfe4-64be-412f-874b-c1f3c5570256",
    "hitokoto": "似花还似非花，也无人惜从教坠。",
    "type": "i",
    "from": "水龙吟·次韵章质夫杨花词",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398124",
    "length": 15
  },
  {
    "id": 5855,
    "uuid": "862c9410-bff1-48ce-a26a-bee64700d42b",
    "hitokoto": "不识庐山真面目，只缘身在此山中。",
    "type": "i",
    "from": "题西林壁",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398125",
    "length": 16
  },
  {
    "id": 5856,
    "uuid": "7544a370-042a-4bfc-9a76-98df8fdae0bf",
    "hitokoto": "停车坐爱枫林晚，霜叶红于二月花。",
    "type": "i",
    "from": "山行",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398125",
    "length": 16
  },
  {
    "id": 5857,
    "uuid": "e4863b47-1abc-4352-822e-2668fe1a54af",
    "hitokoto": "春城无处不飞花，寒食东风御柳斜。",
    "type": "i",
    "from": "寒食 / 寒食日即事",
    "from_who": "韩翃",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398126",
    "length": 16
  },
  {
    "id": 5858,
    "uuid": "936ec3ab-da2e-4f92-8727-47256b21769b",
    "hitokoto": "乱山残雪夜，孤烛异乡人。",
    "type": "i",
    "from": "除夜 / 巴山道中除夜书怀 / 除夜有怀",
    "from_who": "崔涂",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398126",
    "length": 12
  },
  {
    "id": 5859,
    "uuid": "df187911-1d7f-46e5-8c62-ad156d9227f0",
    "hitokoto": "合抱之木，生于毫末；九层之台，起于累土；千里之行，始于足下。",
    "type": "i",
    "from": "老子·德经·第六十四章",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398126",
    "length": 30
  },
  {
    "id": 5860,
    "uuid": "d857c6b4-8508-4b14-9154-d328663c2ce1",
    "hitokoto": "生当作人杰，死亦为鬼雄。",
    "type": "i",
    "from": "夏日绝句",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398127",
    "length": 12
  },
  {
    "id": 5861,
    "uuid": "40fb2d1c-8d6f-4ff4-baa4-b3b73d00e2db",
    "hitokoto": "青枫江上秋帆远，白帝城边古木疏。",
    "type": "i",
    "from": "送李少府贬峡中王少府贬长沙",
    "from_who": "高适",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398127",
    "length": 16
  },
  {
    "id": 5862,
    "uuid": "62524288-33b8-42eb-9b7f-4ace2c9bee7c",
    "hitokoto": "何须浅碧深红色，自是花中第一流。",
    "type": "i",
    "from": "鹧鸪天·桂花",
    "from_who": "李清照",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398127",
    "length": 16
  },
  {
    "id": 5863,
    "uuid": "78cc7e38-4eb8-4175-9101-777f58f0523e",
    "hitokoto": "爆竹声中一岁除，春风送暖入屠苏。",
    "type": "i",
    "from": "元日",
    "from_who": "王安石",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398128",
    "length": 16
  },
  {
    "id": 5864,
    "uuid": "f25d3108-7222-4d00-8e71-5e548796db1d",
    "hitokoto": "云母屏风烛影深，长河渐落晓星沉。",
    "type": "i",
    "from": "嫦娥",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398128",
    "length": 16
  },
  {
    "id": 5865,
    "uuid": "d9c73dc6-caa7-4e31-b126-f428f4e9d4a9",
    "hitokoto": "巧笑倩兮，美目盼兮，素以为绚兮。",
    "type": "i",
    "from": "论语·八佾篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398128",
    "length": 16
  },
  {
    "id": 5866,
    "uuid": "d717508e-9195-4398-84e4-a100312aabee",
    "hitokoto": "漠漠水田飞白鹭，阴阴夏木啭黄鹂。",
    "type": "i",
    "from": "积雨辋川庄作 / 秋归辋川庄作",
    "from_who": "王维",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398129",
    "length": 16
  },
  {
    "id": 5867,
    "uuid": "d9e150a4-0264-4420-8295-8c68f2dea7b2",
    "hitokoto": "千金纵买相如赋，脉脉此情谁诉。",
    "type": "i",
    "from": "摸鱼儿·更能消几番风雨",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398129",
    "length": 15
  },
  {
    "id": 5868,
    "uuid": "6d997ef0-28f8-438a-b29e-1e641b024071",
    "hitokoto": "一寸相思千万绪。人间没个安排处。",
    "type": "i",
    "from": "蝶恋花·春暮",
    "from_who": "李冠",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398129",
    "length": 16
  },
  {
    "id": 5869,
    "uuid": "5d4185c6-4e3f-46be-acaf-046738c100e4",
    "hitokoto": "胜日寻芳泗水滨，无边光景一时新。",
    "type": "i",
    "from": "春日",
    "from_who": "朱熹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398129",
    "length": 16
  },
  {
    "id": 5870,
    "uuid": "3e77587e-5942-4c3f-9fa6-7b6689741ac7",
    "hitokoto": "清风明月无人管，并作南楼一味凉。",
    "type": "i",
    "from": "鄂州南楼书事",
    "from_who": "黄庭坚",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398130",
    "length": 16
  },
  {
    "id": 5871,
    "uuid": "fa63b704-a3c2-4bdf-a746-1c4aad00f151",
    "hitokoto": "昔我往矣，杨柳依依。",
    "type": "i",
    "from": "采薇",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398130",
    "length": 10
  },
  {
    "id": 5872,
    "uuid": "414351a1-e71f-470c-9934-db7fe1ce5ce8",
    "hitokoto": "有三秋桂子，十里荷花。",
    "type": "i",
    "from": "望海潮·东南形胜",
    "from_who": "柳永",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398130",
    "length": 11
  },
  {
    "id": 5873,
    "uuid": "05044964-363b-4f57-a9d1-9089dfefec0c",
    "hitokoto": "数人世相逢，百年欢笑，能得几回又。",
    "type": "i",
    "from": "摸鱼儿·记年时人人何处",
    "from_who": "何梦桂",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586398131",
    "length": 17
  },
  {
    "id": 5874,
    "uuid": "238f79a7-7854-4b54-9a98-6dc876cd3614",
    "hitokoto": "红泪偷垂，满眼春风百事非。",
    "type": "i",
    "from": "采桑子·当时错",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398131",
    "length": 13
  },
  {
    "id": 5875,
    "uuid": "b4bf82c4-578d-4f39-a030-21c041a19bcd",
    "hitokoto": "相看两不厌，只有敬亭山。",
    "type": "i",
    "from": "独坐敬亭山",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398131",
    "length": 12
  },
  {
    "id": 5876,
    "uuid": "d5702d51-e64d-4d11-8805-9fb629531fab",
    "hitokoto": "汴水流，泗水流，流到瓜州古渡头。吴山点点愁。",
    "type": "i",
    "from": "长相思·汴水流",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398132",
    "length": 22
  },
  {
    "id": 5877,
    "uuid": "f1b9ef22-744b-4684-a9fd-e2aa46a78e2c",
    "hitokoto": "垂死病中惊坐起，暗风吹雨入寒窗。",
    "type": "i",
    "from": "闻乐天授江州司马",
    "from_who": "元稹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398132",
    "length": 16
  },
  {
    "id": 5878,
    "uuid": "20ce1f5f-b69b-46af-8117-9e48c01679c0",
    "hitokoto": "若言琴上有琴声，放在匣中何不鸣？",
    "type": "i",
    "from": "琴诗",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398132",
    "length": 16
  },
  {
    "id": 5879,
    "uuid": "800a7e0b-92c7-4058-acc2-51260cfb6d41",
    "hitokoto": "恰同学少年，风华正茂；书生意气，挥斥方遒。",
    "type": "i",
    "from": "沁园春·长沙",
    "from_who": "毛泽东",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398133",
    "length": 21
  },
  {
    "id": 5880,
    "uuid": "d8d8819d-957e-47c1-9943-208be84fbc14",
    "hitokoto": "唯有门前镜湖水，春风不改旧时波。",
    "type": "i",
    "from": "回乡偶书二首",
    "from_who": "贺知章",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398133",
    "length": 16
  },
  {
    "id": 5881,
    "uuid": "ec540c3b-75fc-428a-9b49-8927ed32abd7",
    "hitokoto": "风淅淅，雨纤纤。难怪春愁细细添。",
    "type": "i",
    "from": "赤枣子·风淅淅",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398133",
    "length": 16
  },
  {
    "id": 5882,
    "uuid": "f8396121-2769-41e4-8267-6c635c27c570",
    "hitokoto": "荷叶罗裙一色裁，芙蓉向脸两边开。",
    "type": "i",
    "from": "采莲曲",
    "from_who": "王昌龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398133",
    "length": 16
  },
  {
    "id": 5883,
    "uuid": "e7edd354-edd1-4f20-afad-30074c948cb0",
    "hitokoto": "路曼曼其修远兮，吾将上下而求索。",
    "type": "i",
    "from": "离骚",
    "from_who": "屈原",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398134",
    "length": 16
  },
  {
    "id": 5884,
    "uuid": "3d9ce682-0261-4360-9103-bc0043c5365e",
    "hitokoto": "相思一夜梅花发，忽到窗前疑是君。",
    "type": "i",
    "from": "有所思",
    "from_who": "卢仝",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398134",
    "length": 16
  },
  {
    "id": 5885,
    "uuid": "8673a1ce-ff63-4365-8652-e7f172ca9209",
    "hitokoto": "荷叶生时春恨生，荷叶枯时秋恨成。",
    "type": "i",
    "from": "暮秋独游曲江",
    "from_who": "李商隐",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398134",
    "length": 16
  },
  {
    "id": 5886,
    "uuid": "e7be2b06-a5c5-4fef-8cf6-48f47b5fd0a3",
    "hitokoto": "见贤思齐焉，见不贤而内自省也。",
    "type": "i",
    "from": "论语·里仁篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398135",
    "length": 15
  },
  {
    "id": 5887,
    "uuid": "062800b5-44eb-487f-b13f-2226fa0b90a0",
    "hitokoto": "弱水三千，我只取一瓢饮。",
    "type": "i",
    "from": "红楼梦·第九十一回",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398135",
    "length": 12
  },
  {
    "id": 5888,
    "uuid": "2d651615-6164-4f20-beaf-29bcc8803685",
    "hitokoto": "青青园中葵，朝露待日晞。",
    "type": "i",
    "from": "长歌行",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398135",
    "length": 12
  },
  {
    "id": 5889,
    "uuid": "2855c7b0-dfc9-455b-838b-8401bf713e24",
    "hitokoto": "楼船夜雪瓜洲渡，铁马秋风大散关。",
    "type": "i",
    "from": "书愤五首·其一",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398136",
    "length": 16
  },
  {
    "id": 5890,
    "uuid": "51262639-ff07-4586-abe9-a9c96df8c4b1",
    "hitokoto": "一壶酒，一竿身，快活如侬有几人。",
    "type": "i",
    "from": "渔父·浪花有意千里雪",
    "from_who": "李煜",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398136",
    "length": 16
  },
  {
    "id": 5891,
    "uuid": "1b11962a-fbc7-4364-ac4b-5733bf7ffe55",
    "hitokoto": "质胜文则野，文胜质则史，文质彬彬，然后君子。",
    "type": "i",
    "from": "论语·雍也篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398136",
    "length": 22
  },
  {
    "id": 5892,
    "uuid": "124d1a27-11f9-4f6c-93dd-e21987386284",
    "hitokoto": "皑如山上雪，皎若云间月。",
    "type": "i",
    "from": "白头吟",
    "from_who": "卓文君",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398137",
    "length": 12
  },
  {
    "id": 5893,
    "uuid": "ce58802f-66f3-4ba3-b907-ebe5b77b8537",
    "hitokoto": "相见争如不见，多情何似无情。",
    "type": "i",
    "from": "西江月·宝髻松松挽就",
    "from_who": "司马光",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398137",
    "length": 14
  },
  {
    "id": 5894,
    "uuid": "0b679523-31ea-4f19-866d-a22a7b519424",
    "hitokoto": "老来情味减，对别酒、怯流年。",
    "type": "i",
    "from": "木兰花慢·滁州送范倅",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398137",
    "length": 14
  },
  {
    "id": 5895,
    "uuid": "283288db-5bfc-4847-9168-e3b0e3f3458c",
    "hitokoto": "今宵酒醒何处？杨柳岸，晓风残月。",
    "type": "i",
    "from": "雨霖铃·寒蝉凄切",
    "from_who": "柳永",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398137",
    "length": 16
  },
  {
    "id": 5896,
    "uuid": "aeaccb4a-00a0-4e53-a6d9-746916e44078",
    "hitokoto": "迢迢牵牛星，皎皎河汉女。",
    "type": "i",
    "from": "迢迢牵牛星",
    "from_who": "佚名",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398138",
    "length": 12
  },
  {
    "id": 5897,
    "uuid": "9bbde2d2-b625-4112-9bf0-1c99011e164a",
    "hitokoto": "依旧，依旧，人与绿杨俱瘦。",
    "type": "i",
    "from": "如梦令·春景",
    "from_who": "秦观",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398138",
    "length": 13
  },
  {
    "id": 5898,
    "uuid": "ba485f03-8ebf-493f-b194-d438b307e90a",
    "hitokoto": "千里莺啼绿映红，水村山郭酒旗风。",
    "type": "i",
    "from": "江南春",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398138",
    "length": 16
  },
  {
    "id": 5899,
    "uuid": "21dfdd60-16eb-49ac-a18b-a2a4cd86ccce",
    "hitokoto": "相见争如不见，多情何似无情。",
    "type": "i",
    "from": "西江月·宝髻松松挽就",
    "from_who": "司马光",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398139",
    "length": 14
  },
  {
    "id": 5900,
    "uuid": "bc39ec69-0c98-4f79-bca4-10ba3a545d5d",
    "hitokoto": "感时花溅泪，恨别鸟惊心。",
    "type": "i",
    "from": "春望",
    "from_who": "杜甫",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398139",
    "length": 12
  },
  {
    "id": 5901,
    "uuid": "41b6c505-74c0-4f3a-89f4-81c3a3fea26d",
    "hitokoto": "春未绿，鬓先丝。人间别久不成悲。",
    "type": "i",
    "from": "鹧鸪天·元夕有所梦",
    "from_who": "姜夔",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398139",
    "length": 16
  },
  {
    "id": 5902,
    "uuid": "a73f6dda-cfce-4a12-b51d-130eb5bd6fab",
    "hitokoto": "丈夫非无泪，不洒离别间。",
    "type": "i",
    "from": "别离",
    "from_who": "陆龟蒙",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398140",
    "length": 12
  },
  {
    "id": 5903,
    "uuid": "13aa09d1-cefd-41db-bd9b-afaee63e15cf",
    "hitokoto": "未觉池塘春草梦，阶前梧叶已秋声。",
    "type": "i",
    "from": "偶成",
    "from_who": "朱熹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398140",
    "length": 16
  },
  {
    "id": 5904,
    "uuid": "6f8d1ce9-59cc-44fa-af63-41a6f9591f46",
    "hitokoto": "殷勤昨夜三更雨，又得浮生一日凉。",
    "type": "i",
    "from": "鹧鸪天·林断山明竹隐墙",
    "from_who": "苏轼",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398140",
    "length": 16
  },
  {
    "id": 5905,
    "uuid": "11d22166-4765-4c0a-8353-9d7627d5167b",
    "hitokoto": "千古兴亡多少事？悠悠。不尽长江滚滚流。",
    "type": "i",
    "from": "南乡子·登京口北固亭有怀",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398141",
    "length": 19
  },
  {
    "id": 5906,
    "uuid": "1dddd3db-b9b4-4860-b9c5-412a8c8289da",
    "hitokoto": "惟将终夜常开眼，报答平生未展眉。",
    "type": "i",
    "from": "遣悲怀三首·其三",
    "from_who": "元稹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398141",
    "length": 16
  },
  {
    "id": 5907,
    "uuid": "cd06b26f-1fee-4c50-b347-dd94cc856760",
    "hitokoto": "草木也知愁，韶华竟白头。",
    "type": "i",
    "from": "唐多令·柳絮",
    "from_who": "曹雪芹",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398142",
    "length": 12
  },
  {
    "id": 5908,
    "uuid": "e1ef5063-3855-4255-85f2-372a30ef751d",
    "hitokoto": "银烛秋光冷画屏，轻罗小扇扑流萤。",
    "type": "i",
    "from": "秋夕",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398480",
    "length": 16
  },
  {
    "id": 5909,
    "uuid": "56f2db50-d33b-4d1e-8e7b-db6f3d6b5b63",
    "hitokoto": "人生得意须尽欢，莫使金樽空对月。",
    "type": "i",
    "from": "将进酒",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398480",
    "length": 16
  },
  {
    "id": 5910,
    "uuid": "dfa0f3eb-d4d0-4fdc-b8e5-5938d1dc4ae1",
    "hitokoto": "众口铄金，积毁销骨。",
    "type": "i",
    "from": "史记·张仪列传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398481",
    "length": 10
  },
  {
    "id": 5911,
    "uuid": "6b8a8aa8-ae0b-457a-adc4-a3d0ea6b6246",
    "hitokoto": "美人自古如名将，不许人间见白头。",
    "type": "i",
    "from": "随园诗话·卷四",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398481",
    "length": 16
  },
  {
    "id": 5912,
    "uuid": "2ddaaff3-232c-4957-9201-32d80a272349",
    "hitokoto": "衰兰送客咸阳道，天若有情天亦老。",
    "type": "i",
    "from": "金铜仙人辞汉歌",
    "from_who": "李贺",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398481",
    "length": 16
  },
  {
    "id": 5913,
    "uuid": "0800bd93-0ac4-48a8-915e-c94383236c53",
    "hitokoto": "少小离家老大回，乡音无改鬓毛衰。",
    "type": "i",
    "from": "回乡偶书二首·其一",
    "from_who": "贺知章",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398482",
    "length": 16
  },
  {
    "id": 5914,
    "uuid": "8c72889b-a0b3-4862-b67e-bafa6a55a76d",
    "hitokoto": "何处望神州？满眼风光北固楼。",
    "type": "i",
    "from": "南乡子·登京口北固亭有怀",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398482",
    "length": 14
  },
  {
    "id": 5915,
    "uuid": "082a46a8-00f7-4051-a86f-4ae2cbad3554",
    "hitokoto": "红颜未老恩先断，斜倚薰笼坐到明。",
    "type": "i",
    "from": "后宫词",
    "from_who": "白居易",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398482",
    "length": 16
  },
  {
    "id": 5916,
    "uuid": "db93a41f-f23e-450b-a045-f46faa943039",
    "hitokoto": "李白如今已仙去，月在青天几圆缺？",
    "type": "i",
    "from": "把酒对月歌",
    "from_who": "唐寅",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398483",
    "length": 16
  },
  {
    "id": 5917,
    "uuid": "1fd4a5ae-ad14-44f8-913d-c2cf7019d4a2",
    "hitokoto": "清明时节雨纷纷，路上行人欲断魂。",
    "type": "i",
    "from": "清明",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398483",
    "length": 16
  },
  {
    "id": 5918,
    "uuid": "55e90610-f2dc-4305-b2bf-aed69e4b92b4",
    "hitokoto": "臣心一片磁针石，不指南方不肯休。",
    "type": "i",
    "from": "扬子江",
    "from_who": "文天祥",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398483",
    "length": 16
  },
  {
    "id": 5919,
    "uuid": "522a8a6e-a437-4590-893a-2b70db947287",
    "hitokoto": "燕子来时新社，梨花落后清明。",
    "type": "i",
    "from": "破阵子·春景",
    "from_who": "晏殊",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398484",
    "length": 14
  },
  {
    "id": 5920,
    "uuid": "34923454-fdba-4aab-a0e7-a831511c2e9b",
    "hitokoto": "青山相待，白云相爱，梦不到紫罗袍共黄金带。",
    "type": "i",
    "from": "山坡羊·道情",
    "from_who": "宋方壶",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398484",
    "length": 21
  },
  {
    "id": 5921,
    "uuid": "6388d87e-81c4-4cdb-b2a0-2e21937b5724",
    "hitokoto": "但使龙城飞将在，不教胡马度阴山。",
    "type": "i",
    "from": "出塞二首",
    "from_who": "王昌龄",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398484",
    "length": 16
  },
  {
    "id": 5922,
    "uuid": "faeb71b9-2eb0-44b2-87da-07a51f93563e",
    "hitokoto": "一别如斯，落尽梨花月又西。",
    "type": "i",
    "from": "采桑子·当时错",
    "from_who": "纳兰性德",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398484",
    "length": 13
  },
  {
    "id": 5923,
    "uuid": "86847a8b-800a-4500-8720-e7620a4e63c9",
    "hitokoto": "晚日寒鸦一片愁。柳塘新绿却温柔。",
    "type": "i",
    "from": "鹧鸪天·晚日寒鸦一片愁",
    "from_who": "辛弃疾",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398485",
    "length": 16
  },
  {
    "id": 5924,
    "uuid": "982cb74f-d57b-4993-9577-c427ba186bfa",
    "hitokoto": "山随平野尽，江入大荒流。",
    "type": "i",
    "from": "渡荆门送别",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398485",
    "length": 12
  },
  {
    "id": 5925,
    "uuid": "077761e0-454a-4c9b-91ca-e65996bdd652",
    "hitokoto": "卧看满天云不动，不知云与我俱东。",
    "type": "i",
    "from": "襄邑道中",
    "from_who": "陈与义",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398485",
    "length": 16
  },
  {
    "id": 5926,
    "uuid": "78757b1f-54e1-480e-a7cd-e6acc2c27cf5",
    "hitokoto": "烟笼寒水月笼沙，夜泊秦淮近酒家。",
    "type": "i",
    "from": "泊秦淮",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398486",
    "length": 16
  },
  {
    "id": 5927,
    "uuid": "8877cee1-da01-4a3b-94e3-483d1a8baea7",
    "hitokoto": "一叫一回肠一断，三春三月忆三巴。",
    "type": "i",
    "from": "宣城见杜鹃花 / 子规",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398486",
    "length": 16
  },
  {
    "id": 5928,
    "uuid": "da99bfa5-4da3-4d78-ab03-0bc90cd72211",
    "hitokoto": "吾十有五而志于学，三十而立，四十而不惑，五十而知天命，六十而耳顺，七十而从心所欲，不逾矩。",
    "type": "i",
    "from": "论语·为政篇",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398486",
    "length": 45
  },
  {
    "id": 5929,
    "uuid": "76bc7d55-e434-4b3d-943b-7a03a59efdfd",
    "hitokoto": "绿树阴浓夏日长，楼台倒影入池塘。",
    "type": "i",
    "from": "山亭夏日",
    "from_who": "高骈",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398487",
    "length": 16
  },
  {
    "id": 5930,
    "uuid": "c93ebf37-578c-4f40-8678-9b6a64939daf",
    "hitokoto": "梅花雪，梨花月，总相思。",
    "type": "i",
    "from": "相见欢·年年负却花期",
    "from_who": "张惠言",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398487",
    "length": 12
  },
  {
    "id": 5931,
    "uuid": "5c315f69-e2e4-48d9-990d-5be84f7468c2",
    "hitokoto": "零落成泥碾作尘，只有香如故。",
    "type": "i",
    "from": "卜算子·咏梅",
    "from_who": "陆游",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398487",
    "length": 14
  },
  {
    "id": 5932,
    "uuid": "d35964fd-1e63-4923-8f14-48a74487a622",
    "hitokoto": "天将降大任于是人也，必先苦其心志，劳其筋骨，饿其体肤，空乏其身，行拂乱其所为。",
    "type": "i",
    "from": "孟子·告子章句下·第十五节",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398488",
    "length": 39
  },
  {
    "id": 5933,
    "uuid": "23c1dc26-7b64-41f9-8d01-8fad4377d224",
    "hitokoto": "兰生幽谷， 不为莫服而不芳。舟在江海，不为莫乘而不浮。君子行义，不为莫知而止休。",
    "type": "i",
    "from": "淮南子·说山训",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398488",
    "length": 40
  },
  {
    "id": 5934,
    "uuid": "45e7399b-539e-4c5a-899f-89d47776f7f0",
    "hitokoto": "遇沉沉不语之士，且莫输心；见悻悻自好之人，应须防口。",
    "type": "i",
    "from": "菜根谭·概论",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398488",
    "length": 26
  },
  {
    "id": 5935,
    "uuid": "25d7a460-e82e-4529-a95b-74a7ac3114d3",
    "hitokoto": "浮云游子意，落日故人情。",
    "type": "i",
    "from": "送友人",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398489",
    "length": 12
  },
  {
    "id": 5936,
    "uuid": "a6aef34c-5efd-4b7f-87f5-5f9a1957e397",
    "hitokoto": "黄鹤一去不复返，白云千载空悠悠。",
    "type": "i",
    "from": "黄鹤楼 / 登黄鹤楼",
    "from_who": "崔颢",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398489",
    "length": 16
  },
  {
    "id": 5937,
    "uuid": "c41946ad-e105-4071-a9bd-5e4ebf6857e2",
    "hitokoto": "北国风光，千里冰封，万里雪飘。",
    "type": "i",
    "from": "沁园春·雪",
    "from_who": "毛泽东",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398489",
    "length": 15
  },
  {
    "id": 5938,
    "uuid": "f81041d4-8738-4d9a-b6c6-100b76feaec4",
    "hitokoto": "梧桐叶上三更雨，叶叶声声是别离。",
    "type": "i",
    "from": "鹧鸪天·一点残红欲尽时",
    "from_who": "周紫芝",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398490",
    "length": 16
  },
  {
    "id": 5939,
    "uuid": "a5bdf4a4-0767-4787-9af2-5c4b12e7dda1",
    "hitokoto": "思君如流水，何有穷已时。",
    "type": "i",
    "from": "室思",
    "from_who": "徐干",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398490",
    "length": 12
  },
  {
    "id": 5940,
    "uuid": "f869bdc5-3626-41de-a826-7869bde3c3e6",
    "hitokoto": "居高声自远，非是藉秋风。",
    "type": "i",
    "from": "蝉",
    "from_who": "虞世南",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398490",
    "length": 12
  },
  {
    "id": 5941,
    "uuid": "cd34fbb3-be49-4f75-afc8-ea513a59d0a1",
    "hitokoto": "儿童散学归来早，忙趁东风放纸鸢。",
    "type": "i",
    "from": "村居",
    "from_who": "高鼎",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398490",
    "length": 16
  },
  {
    "id": 5942,
    "uuid": "d7e791d8-0236-4df9-98e7-a9397e4aff3a",
    "hitokoto": "北方有佳人，绝世而独立。",
    "type": "i",
    "from": "李延年歌",
    "from_who": "李延年",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398491",
    "length": 12
  },
  {
    "id": 5943,
    "uuid": "a80faa05-e166-4da4-a416-979f40806f34",
    "hitokoto": "寒夜客来茶当酒，竹炉汤沸火初红。",
    "type": "i",
    "from": "寒夜",
    "from_who": "杜耒",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398491",
    "length": 16
  },
  {
    "id": 5944,
    "uuid": "980f292f-1484-4a8c-aebc-db99087a3c1e",
    "hitokoto": "看朱成碧思纷纷，憔悴支离为忆君。",
    "type": "i",
    "from": "如意娘",
    "from_who": "武则天",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398491",
    "length": 16
  },
  {
    "id": 5945,
    "uuid": "5a0b4140-36ca-4998-9100-7b26ab6e0988",
    "hitokoto": "远上寒山石径斜，白云深处有人家。",
    "type": "i",
    "from": "山行",
    "from_who": "杜牧",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398492",
    "length": 16
  },
  {
    "id": 5946,
    "uuid": "7408b604-8bd6-4b4a-9f1b-982449ad8567",
    "hitokoto": "春色满园关不住，一枝红杏出墙来。",
    "type": "i",
    "from": "游园不值",
    "from_who": "叶绍翁",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398492",
    "length": 16
  },
  {
    "id": 5947,
    "uuid": "636294ed-2fe1-4998-931d-229efd6521b3",
    "hitokoto": "当君怀归日，是妾断肠时。",
    "type": "i",
    "from": "春思",
    "from_who": "李白",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "api",
    "created_at": "1586398492",
    "length": 12
  },
  {
    "id": 5974,
    "uuid": "20713444-8a59-44b7-89e3-e8cf990a3857",
    "hitokoto": "千年后，锦城相吊，遇草堂翁。",
    "type": "i",
    "from": "八声甘州·读诸葛武侯传",
    "from_who": "王质",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587742863",
    "length": 14
  },
  {
    "id": 6015,
    "uuid": "a743764d-a7cd-4d20-b188-470049b3b88f",
    "hitokoto": "路漫漫其修远兮，吾将上下而求索。",
    "type": "i",
    "from": "离骚",
    "from_who": "屈原",
    "creator": "今天不散步",
    "creator_uid": 5722,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1588567048",
    "length": 16
  },
  {
    "id": 6020,
    "uuid": "c22767e1-15c1-44c6-b6c6-562057634699",
    "hitokoto": "仁不行商、义不守财；情不立威，善不居官；慈不掌兵，柔不监国。",
    "type": "i",
    "from": "增广贤文",
    "from_who": null,
    "creator": "青面灵圣",
    "creator_uid": 5873,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586776967",
    "length": 30
  },
  {
    "id": 6024,
    "uuid": "a2ffe24c-a615-4222-a065-0ea1c3e8c645",
    "hitokoto": "星垂平野阔，月涌大江流。",
    "type": "i",
    "from": "旅夜书怀",
    "from_who": "杜甫",
    "creator": "一剑还",
    "creator_uid": 6207,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1589357291",
    "length": 12
  },
  {
    "id": 6025,
    "uuid": "8866ff3c-ecc9-4d1b-8cf4-dd0b742bcacf",
    "hitokoto": "离离原上草，一岁一枯荣。",
    "type": "i",
    "from": "草",
    "from_who": "白居易",
    "creator": "本事",
    "creator_uid": 6206,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1589357161",
    "length": 12
  },
  {
    "id": 6026,
    "uuid": "db09d1e8-f2ce-4b4e-af26-4259cdb8a60f",
    "hitokoto": "故人西辞黄鹤楼，烟花三月下扬州。",
    "type": "i",
    "from": "黄鹤楼送孟浩然之广陵",
    "from_who": "李白",
    "creator": "本事",
    "creator_uid": 6206,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1589357238",
    "length": 16
  },
  {
    "id": 6027,
    "uuid": "a258b954-64c1-42d1-99b9-81ec90c66157",
    "hitokoto": "相思似海深，旧事如天远。",
    "type": "i",
    "from": "卜算子·答施",
    "from_who": "乐婉",
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590306925",
    "length": 12
  },
  {
    "id": 6056,
    "uuid": "99fc42fe-f409-4cd2-a9c7-70c35948c5c4",
    "hitokoto": "勤學如奮起之苗，不見其增，日有所長；輟學如磨刀之石，不見其損，日有所虧。",
    "type": "i",
    "from": "陶淵明",
    "from_who": null,
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587650136",
    "length": 36
  },
  {
    "id": 6059,
    "uuid": "aa6bf2cd-ca9b-4e8f-a482-c2496bab26c9",
    "hitokoto": "行到水穷处，坐看云起时。",
    "type": "i",
    "from": "终南别业",
    "from_who": "王维",
    "creator": "voyager",
    "creator_uid": 6023,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587707837",
    "length": 12
  },
  {
    "id": 6060,
    "uuid": "cb6ec72f-38dd-462e-932e-4649635905ac",
    "hitokoto": "无奈被些名利缚，无奈被些情担阁，可惜风流总闲却。",
    "type": "i",
    "from": "千秋岁引·秋景",
    "from_who": "王安石",
    "creator": "临川入梦",
    "creator_uid": 6030,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587730306",
    "length": 24
  },
  {
    "id": 6092,
    "uuid": "97309419-808c-4a8e-a937-d8503f109fc7",
    "hitokoto": "生当复来归，死当长相思。",
    "type": "i",
    "from": "留别妻",
    "from_who": "苏武",
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590307036",
    "length": 12
  },
  {
    "id": 6093,
    "uuid": "bb678c6d-69b0-489e-8a04-b7c4c1aec745",
    "hitokoto": "愿我如星君如月，夜夜流光相皎洁。",
    "type": "i",
    "from": "车遥遥篇",
    "from_who": "范成大",
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590306845",
    "length": 16
  },
  {
    "id": 6094,
    "uuid": "984b3637-f5b9-48c3-b032-5e116f8f5861",
    "hitokoto": "山有木兮木有枝，心悦君兮君不知。",
    "type": "i",
    "from": "越人歌",
    "from_who": null,
    "creator": "qwqbear",
    "creator_uid": 3516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590306742",
    "length": 16
  },
  {
    "id": 6099,
    "uuid": "4464317a-705e-4959-aea5-e5fc991a07d2",
    "hitokoto": "回首向来萧瑟处，归去， 也无风雨也无晴。",
    "type": "i",
    "from": "定风波",
    "from_who": "苏轼",
    "creator": "Vaine0",
    "creator_uid": 6260,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590134642",
    "length": 20
  },
  {
    "id": 6163,
    "uuid": "bfa03b47-582b-4c9c-8de2-573e625ed9b9",
    "hitokoto": "未觉池塘春草梦，阶前梧叶已秋声。",
    "type": "i",
    "from": "偶成",
    "from_who": "朱熹",
    "creator": "怀表小兔",
    "creator_uid": 6212,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589519762",
    "length": 16
  },
  {
    "id": 6183,
    "uuid": "16e37d09-6ccf-4ee8-b1ee-f5d3bd553500",
    "hitokoto": "急雨收残暑，梧桐一叶惊。",
    "type": "i",
    "from": "西游记",
    "from_who": "吴承恩",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590373870",
    "length": 12
  },
  {
    "id": 6193,
    "uuid": "91e63058-6289-44db-b3fe-f8ddb551f5da",
    "hitokoto": "兼山艮，君子以思不出其位。",
    "type": "i",
    "from": "论语·宪问",
    "from_who": null,
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482291",
    "length": 13
  },
  {
    "id": 6284,
    "uuid": "da2678d5-05bb-413c-85e8-bcfd54b9189a",
    "hitokoto": "多谢梅花，伴我微吟。",
    "type": "i",
    "from": "高阳台·除夜",
    "from_who": "韩疁",
    "creator": "周楼沉",
    "creator_uid": 6650,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1594100844",
    "length": 10
  },
  {
    "id": 6331,
    "uuid": "b425a826-51d4-4d99-9b7a-daf958cbc1bf",
    "hitokoto": "谁一旦凝视过美本身 / 就已经把自己委身给了死亡。",
    "type": "i",
    "from": "Tristan",
    "from_who": "普拉滕",
    "creator": "朏之长生者",
    "creator_uid": 6574,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593261103",
    "length": 25
  },
  {
    "id": 6332,
    "uuid": "ba9e21d5-6da9-4722-b42e-dfa2a437c30d",
    "hitokoto": "什么是玫瑰？为了被斩首而生长的头颅。",
    "type": "i",
    "from": "阿多尼斯诗集",
    "from_who": "阿多尼斯",
    "creator": "朏之长生者",
    "creator_uid": 6574,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593261227",
    "length": 18
  },
  {
    "id": 6333,
    "uuid": "b9e6af8a-af98-4cef-bbfe-931efdaa0b34",
    "hitokoto": "什么是尘土？从大地之肺发出的一声叹息。",
    "type": "i",
    "from": "阿多尼斯诗集",
    "from_who": "阿多尼斯",
    "creator": "朏之长生者",
    "creator_uid": 6574,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593261255",
    "length": 19
  },
  {
    "id": 6334,
    "uuid": "847e94ba-b54a-4c65-a687-381214e50e1d",
    "hitokoto": "什么是焦虑？褶子和皱纹，在神经的丝绸上。",
    "type": "i",
    "from": "阿多尼斯诗集",
    "from_who": "阿多尼斯",
    "creator": "朏之长生者",
    "creator_uid": 6574,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593261277",
    "length": 20
  },
  {
    "id": 6335,
    "uuid": "ce654df7-6462-47b4-ab63-421c6f98a72f",
    "hitokoto": "什么是时光？我们穿上的衣服，却再也脱不下来。",
    "type": "i",
    "from": "阿多尼斯诗集",
    "from_who": "阿多尼斯",
    "creator": "朏之长生者",
    "creator_uid": 6574,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593261310",
    "length": 22
  },
  {
    "id": 6344,
    "uuid": "272caab9-17cd-44a5-9705-e8f0c1ba8753",
    "hitokoto": "欲买桂花同载酒，终不似，少年游。",
    "type": "i",
    "from": "唐多令·芦叶满汀洲",
    "from_who": "刘过",
    "creator": "jscblack",
    "creator_uid": 6603,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593526117",
    "length": 16
  },
  {
    "id": 6355,
    "uuid": "d9fac676-df5a-4bad-afac-665aa2a82408",
    "hitokoto": "但行好事，莫问前程。",
    "type": "i",
    "from": "增广贤文",
    "from_who": "佚名",
    "creator": "ZigZagK",
    "creator_uid": 6623,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593791760",
    "length": 10
  },
  {
    "id": 6378,
    "uuid": "5b85b9b2-3331-4c9f-b4dc-d3fd25c4b343",
    "hitokoto": "人生如逆旅，我亦是行人。",
    "type": "i",
    "from": "临江仙·送钱穆父",
    "from_who": "苏轼",
    "creator": "长亭",
    "creator_uid": 6758,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1595319722",
    "length": 12
  },
  {
    "id": 6394,
    "uuid": "85eadd99-6d8d-45c9-a5f9-043627aff376",
    "hitokoto": "海内存知己，天涯若比邻。",
    "type": "i",
    "from": "送杜少府之任蜀州",
    "from_who": "王勃",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596109154",
    "length": 12
  },
  {
    "id": 6395,
    "uuid": "2ef85357-9b1a-4d11-9c78-e0e54af3d0cd",
    "hitokoto": "伤心桥下春波绿，曾是惊鸿照影来。",
    "type": "i",
    "from": "《沈园二首》(其一)",
    "from_who": "陆游",
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596112405",
    "length": 16
  },
  {
    "id": 6398,
    "uuid": "b05d8fa6-33a3-4a4c-9c7e-34e048c81f91",
    "hitokoto": "生尽欢，死无憾。",
    "type": "i",
    "from": "钗头凤·陆游",
    "from_who": "陆游",
    "creator": "dr34m",
    "creator_uid": 6843,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596114653",
    "length": 8
  },
  {
    "id": 6429,
    "uuid": "74613b4e-490c-442a-ad71-76f2ed9d4cbe",
    "hitokoto": "最是人间留不住，朱颜辞镜花辞树。",
    "type": "i",
    "from": "蝶恋花·阅尽天涯离别苦",
    "from_who": "王国维",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596763382",
    "length": 16
  },
  {
    "id": 6430,
    "uuid": "b883d487-2423-4941-b812-6b4f46e91be5",
    "hitokoto": "明年此日青云去，却笑人间举子忙。",
    "type": "i",
    "from": "鹧鸪天·送廓之秋试",
    "from_who": "辛弃疾",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596763601",
    "length": 16
  },
  {
    "id": 6431,
    "uuid": "bec2edbe-b0cb-4d35-af80-ff1171143560",
    "hitokoto": "沾衣欲湿杏花雨，吹面不寒杨柳风。",
    "type": "i",
    "from": "绝句·古木阴中系短篷",
    "from_who": "志南",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596763758",
    "length": 16
  },
  {
    "id": 6432,
    "uuid": "360300e0-3fa7-4b1e-9b8a-9ac7029764a3",
    "hitokoto": "君埋泉下泥销骨，我寄人间雪满头。",
    "type": "i",
    "from": "梦微之",
    "from_who": "白居易",
    "creator": "顾及",
    "creator_uid": 6897,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596763830",
    "length": 16
  },
  {
    "id": 6453,
    "uuid": "2249463f-359a-43ac-b018-9f0465905a72",
    "hitokoto": "不愿勾起相思，不敢出门看月；偏偏月进窗来，害我相思一夜。",
    "type": "i",
    "from": "也是微云",
    "from_who": "胡适",
    "creator": "alterem",
    "creator_uid": 4351,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1598255435",
    "length": 28
  },
  {
    "id": 6466,
    "uuid": "3a7e1f68-aa0b-44c8-ac1e-047075ed4a70",
    "hitokoto": "不要说我们一无所有，我们要做天下的主人！",
    "type": "i",
    "from": "国际歌",
    "from_who": "欧仁·鲍狄埃",
    "creator": "Serastan",
    "creator_uid": 7394,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1602079367",
    "length": 20
  },
  {
    "id": 6470,
    "uuid": "c3ab7e10-5de4-403e-9e55-c0b0366a1c60",
    "hitokoto": "如何肯到清秋日，已带斜阳又带蝉。",
    "type": "i",
    "from": "柳",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602931998",
    "length": 16
  },
  {
    "id": 6473,
    "uuid": "b3c90c70-1a2a-4b7c-8b6e-cdca10b7f4f3",
    "hitokoto": "吾道本无我，未曾嫌世人。如今到尘世，弥觉此心真",
    "type": "i",
    "from": "寓言",
    "from_who": null,
    "creator": "李无生",
    "creator_uid": 7454,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602692836",
    "length": 23
  },
  {
    "id": 6499,
    "uuid": "ee0ebb2a-a5a3-4ccc-84f0-94a109066727",
    "hitokoto": "老夫聊发少年狂，左牵黄，右擎苍。",
    "type": "i",
    "from": "江城子·密州出猎",
    "from_who": "苏轼",
    "creator": "柒染",
    "creator_uid": 7324,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601639226",
    "length": 16
  },
  {
    "id": 6532,
    "uuid": "35f748a6-fe8a-4c21-bded-de50447d51cd",
    "hitokoto": "同是天涯沦落人，相逢何必曾相识。",
    "type": "i",
    "from": "琵琶行",
    "from_who": "白居易",
    "creator": "drinktoomuchsks",
    "creator_uid": 7127,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599368996",
    "length": 16
  },
  {
    "id": 6535,
    "uuid": "637c3c2c-3c06-4f62-89d9-d6e9ad06eb5b",
    "hitokoto": "早知如此绊人心，何如当初莫相识。",
    "type": "i",
    "from": "秋风词",
    "from_who": "李白",
    "creator": "drinktoomuchsks",
    "creator_uid": 7127,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599368935",
    "length": 16
  },
  {
    "id": 6615,
    "uuid": "067fd14f-defb-4637-95f1-2673c9969090",
    "hitokoto": "We can bring to birth a new world from the ashes of the old.",
    "type": "i",
    "from": "Solidarity Forever",
    "from_who": "Pete Seeger",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603517855",
    "length": 60
  },
  {
    "id": 6659,
    "uuid": "e940e95c-07cb-4358-b1d8-a9644fe74acb",
    "hitokoto": "磨盘战地人犹识，磷火常同日色鲜。",
    "type": "i",
    "from": "读残明漫记四首",
    "from_who": "刘彬",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1603727191",
    "length": 16
  },
  {
    "id": 6681,
    "uuid": "02843879-ab0c-45a4-9a46-8549a5f84a08",
    "hitokoto": "总是以为我们会长久，可能因为我们会长久，然后这样我们就长久。",
    "type": "i",
    "from": "三行情书",
    "from_who": "北川理惠",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604797126",
    "length": 30
  },
  {
    "id": 6688,
    "uuid": "1319a697-da0e-4c02-a494-a5741e37bec7",
    "hitokoto": "莫等闲，白了少年头，空悲切。",
    "type": "i",
    "from": "满江红",
    "from_who": "岳飞",
    "creator": "Harry 应旻昊",
    "creator_uid": 7744,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605326564",
    "length": 14
  },
  {
    "id": 6702,
    "uuid": "f0913087-f879-46b5-8a4b-420beb262470",
    "hitokoto": "一别之后，两地相思，只道是三四月，又谁知五六年。",
    "type": "i",
    "from": "怨郎诗",
    "from_who": "卓文君",
    "creator": "小布",
    "creator_uid": 7688,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604889422",
    "length": 24
  },
  {
    "id": 6729,
    "uuid": "2565cf46-f467-46a2-8b58-1716d3c5d932",
    "hitokoto": "黑白谁能用入玄，千回生死体方圆。",
    "type": "i",
    "from": "咏棋子赠弈僧",
    "from_who": "张乔 (唐)",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605408726",
    "length": 16
  },
  {
    "id": 6741,
    "uuid": "705cf7a0-5b39-4144-a396-cae1339c2d72",
    "hitokoto": "春有百花秋有月，夏有凉风冬有雪。",
    "type": "i",
    "from": "颂古五十五首其一",
    "from_who": "释绍昙",
    "creator": "Soiltary、K",
    "creator_uid": 3915,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605852594",
    "length": 16
  },
  {
    "id": 6745,
    "uuid": "59cefaa7-9266-47b2-8da7-989baf983df3",
    "hitokoto": "钱塘依旧，潮生潮落。",
    "type": "i",
    "from": "传言玉女·钱塘元夕",
    "from_who": "汪元量",
    "creator": "ACwisher",
    "creator_uid": 7830,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606108279",
    "length": 10
  },
  {
    "id": 6746,
    "uuid": "95bad63d-b49d-4325-98dd-7b26babd93f6",
    "hitokoto": "山川同一色，浩若涉大荒。",
    "type": "i",
    "from": "牛口见月",
    "from_who": "苏轼",
    "creator": "ACwisher",
    "creator_uid": 7830,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606108329",
    "length": 12
  },
  {
    "id": 6749,
    "uuid": "ac0c83d2-1d4c-4e53-b432-85e4d42320d3",
    "hitokoto": "灯把黑夜，烫了一个洞。",
    "type": "i",
    "from": "灯",
    "from_who": "姜二嫚 | 七岁",
    "creator": "TuTu",
    "creator_uid": 7853,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606292544",
    "length": 11
  },
  {
    "id": 6750,
    "uuid": "8c17bb6f-e87b-4381-ab1b-c75143d1dc45",
    "hitokoto": "花，不知道自己就是春天。",
    "type": "i",
    "from": "春天",
    "from_who": "谢武彰",
    "creator": "TuTu",
    "creator_uid": 7853,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606292747",
    "length": 12
  },
  {
    "id": 6767,
    "uuid": "80d3bb1f-3c35-4261-8ae6-56a5bfcdb940",
    "hitokoto": "听风雪喧嚷，看流星在飞翔； 我的心向我呼唤：去动荡的远方……",
    "type": "i",
    "from": "歌唱动荡的青春",
    "from_who": "亚历山德拉·尼·巴赫慕托娃",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606403131",
    "length": 30
  },
  {
    "id": 6775,
    "uuid": "e63b7906-ef02-41f6-9260-0863e6d6ba80",
    "hitokoto": "今日欢呼孙大圣，只缘妖雾又重来。",
    "type": "i",
    "from": "七律·和郭沫若同志",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405036",
    "length": 16
  },
  {
    "id": 6776,
    "uuid": "151d01a7-e120-4e83-b919-65f5e9a905c4",
    "hitokoto": "自信人生二百年，会当水击三千里。",
    "type": "i",
    "from": "残句",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405120",
    "length": 16
  },
  {
    "id": 6777,
    "uuid": "8313e5d9-248a-421a-9e35-78ed7f8defce",
    "hitokoto": "鹰击长空，鱼翔浅底，万类霜天竞自由。怅寥廓，问苍茫大地，谁主沉浮？",
    "type": "i",
    "from": "沁园春·长沙",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405154",
    "length": 33
  },
  {
    "id": 6778,
    "uuid": "04178872-4dfa-4fc1-adfa-1badba76c499",
    "hitokoto": "曾记否，到中流击水，浪遏飞舟？",
    "type": "i",
    "from": "沁园春·长沙",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405176",
    "length": 15
  },
  {
    "id": 6779,
    "uuid": "077a7e4f-7c39-4e42-af62-15ef0576ebf2",
    "hitokoto": "雄关漫道真如铁，而今迈步从头越。",
    "type": "i",
    "from": "忆秦娥·娄山关",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405203",
    "length": 16
  },
  {
    "id": 6780,
    "uuid": "c6cd8819-7204-4fe2-8ea7-0ae7912c7325",
    "hitokoto": "江山如此多娇，引无数英雄竞折腰。",
    "type": "i",
    "from": "沁园春·雪",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405237",
    "length": 16
  },
  {
    "id": 6781,
    "uuid": "100c28f4-2124-4686-9e1f-8e1698195a8a",
    "hitokoto": "俱往矣，数风流人物，还看今朝。",
    "type": "i",
    "from": "沁园春·雪",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405250",
    "length": 15
  },
  {
    "id": 6782,
    "uuid": "e528c5fa-3e85-4312-9a50-77fc6c18dd7d",
    "hitokoto": "天若有情天亦老，人间正道是沧桑。",
    "type": "i",
    "from": "七律·人民解放军占领南京",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405271",
    "length": 16
  },
  {
    "id": 6783,
    "uuid": "96e1719b-6002-4f46-a070-10b15fa7a2de",
    "hitokoto": "寂寞嫦娥舒广袖，万里长空且为忠魂舞。",
    "type": "i",
    "from": "蝶恋花·答李淑一",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405304",
    "length": 18
  },
  {
    "id": 6784,
    "uuid": "cc443853-5281-41f7-a4d6-a116ec115149",
    "hitokoto": "为有牺牲多壮志，敢教日月换新天。",
    "type": "i",
    "from": "七律·到韶山",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405321",
    "length": 16
  },
  {
    "id": 6785,
    "uuid": "dfae0eaf-4e96-43d1-998f-9ebccada279e",
    "hitokoto": "当年忠贞为国酬，何曾怕断头？如今天下红遍，江山靠谁守？业未竟，身躯倦，鬓已秋；你我之辈，忍将夙愿，付与东流？",
    "type": "i",
    "from": "诉衷情·赠周总理",
    "from_who": "毛泽东",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606405389",
    "length": 54
  },
  {
    "id": 6789,
    "uuid": "a519c52c-3fe1-49f6-a432-ac0f6274ae1c",
    "hitokoto": "城南小陌又逢春，只见梅花不见人。",
    "type": "i",
    "from": "十二月二日夜梦游沈氏园亭",
    "from_who": "陆游",
    "creator": "陈鱼宴",
    "creator_uid": 7876,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606524766",
    "length": 16
  },
  {
    "id": 6802,
    "uuid": "bc54224b-43af-42ac-a2a8-7f6c4dce247e",
    "hitokoto": "雁子南飞时，故人忆往事。",
    "type": "i",
    "from": "醉柳引·故人安在兮",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606907197",
    "length": 12
  },
  {
    "id": 6934,
    "uuid": "f1198625-25a6-4d1f-8fe4-7d6cc21ffefc",
    "hitokoto": "古有一言腰相印，谁教他、满箧婴鳞疏。",
    "type": "i",
    "from": "贺新郎·宣引东华去",
    "from_who": "刘克庄",
    "creator": "勾股定理",
    "creator_uid": 8216,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610256031",
    "length": 18
  },
  {
    "id": 6970,
    "uuid": "c7212d39-ec93-499e-b073-077990279357",
    "hitokoto": "武侯祠堂常邻近，一体君臣祭祀同。",
    "type": "i",
    "from": "咏怀古迹五首·其四",
    "from_who": "杜甫",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613568109",
    "length": 16
  },
  {
    "id": 6976,
    "uuid": "38b67194-dac6-4f7f-83f8-30f28d811989",
    "hitokoto": "天生我材必有用，千金散尽还复来。",
    "type": "i",
    "from": "将进酒",
    "from_who": "李白",
    "creator": "BlueSu",
    "creator_uid": 8526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613570449",
    "length": 16
  },
  {
    "id": 6986,
    "uuid": "01f841ee-2092-4bec-826a-e6cd48235f1d",
    "hitokoto": "窗外日光弹指过，席前花影坐前移。",
    "type": "i",
    "from": "水浒传·第二回",
    "from_who": "施耐庵",
    "creator": "SL_MC_AW",
    "creator_uid": 8363,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611832590",
    "length": 16
  },
  {
    "id": 6988,
    "uuid": "b84b9c14-5adc-4736-8afe-bd1b6fa89a1e",
    "hitokoto": "回眸一笑百媚生，六宫粉黛无颜色。",
    "type": "i",
    "from": "长恨歌",
    "from_who": "白居易",
    "creator": "南婷婷",
    "creator_uid": 8367,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611846856",
    "length": 16
  },
  {
    "id": 6994,
    "uuid": "5b15e5f1-02c9-4ee5-ab59-ce96dab37971",
    "hitokoto": "若要断酒法，醒眼看醉人。",
    "type": "i",
    "from": "沪谚",
    "from_who": "胡祖德",
    "creator": "卫庄",
    "creator_uid": 8393,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612185961",
    "length": 12
  },
  {
    "id": 6995,
    "uuid": "f97b5288-7a1a-42f5-8c48-0df2a893ed82",
    "hitokoto": "白苎新袍入嫩凉。春蚕食叶响回廊，禹门已准桃花浪，月殿先收桂子香。鹏北海，凤朝阳。又携书剑路茫茫。明年此日青云去，却笑人间举子忙。",
    "type": "i",
    "from": "鹧鸪天·送廓之秋试",
    "from_who": "辛弃疾",
    "creator": "卫庄",
    "creator_uid": 8393,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612186098",
    "length": 64
  },
  {
    "id": 6996,
    "uuid": "b9f6814d-f464-4737-92b6-c2f6d24002b4",
    "hitokoto": "曾经沧海难为水，除却巫山不是云。取次花丛懒回顾，半缘修道半缘君。",
    "type": "i",
    "from": "离思五首·其四",
    "from_who": "元稹",
    "creator": "卫庄",
    "creator_uid": 8393,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612186185",
    "length": 32
  },
  {
    "id": 7059,
    "uuid": "3887c7cb-7bff-41f2-9a14-d8db79c16d59",
    "hitokoto": "长月黄昏后，伫立露沾身；莫问我为谁，我自待伊人。",
    "type": "i",
    "from": "万叶集",
    "from_who": "佚名",
    "creator": "CXXXXXX",
    "creator_uid": 7592,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613829161",
    "length": 24
  },
  {
    "id": 7123,
    "uuid": "18bd8298-4f42-42ea-a754-5826ff4e4ccd",
    "hitokoto": "井底点灯深烛伊，共郎长行莫围棋。",
    "type": "i",
    "from": "南歌子词二首",
    "from_who": "温庭筠",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619248502",
    "length": 16
  },
  {
    "id": 7124,
    "uuid": "58294a73-c3a0-48f9-9374-9027c0527cdb",
    "hitokoto": "玲珑骰子安红豆，入骨相思知不知。",
    "type": "i",
    "from": "南歌子词二首",
    "from_who": "温庭筠",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619248565",
    "length": 16
  },
  {
    "id": 7285,
    "uuid": "0e4d2234-2862-4acc-80ff-cfde681123c6",
    "hitokoto": "灭六国者，非秦也，六国也。",
    "type": "i",
    "from": "阿房宫赋",
    "from_who": "杜牧",
    "creator": "朱佳熠",
    "creator_uid": 9963,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1627917866",
    "length": 13
  },
  {
    "id": 7288,
    "uuid": "fbf19df5-1c20-496c-9649-e8c5b43a6653",
    "hitokoto": "倚南窗以寄傲，审容膝之易安。园日涉以成趣，门虽设而常关。",
    "type": "i",
    "from": "归去来兮辞",
    "from_who": "陶渊明",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620047856",
    "length": 28
  },
  {
    "id": 7312,
    "uuid": "086aa54b-0a99-4a29-86d5-6b83c467c8a3",
    "hitokoto": "读万卷书，行万里路。",
    "type": "i",
    "from": "《画禅室随笔——卷二》",
    "from_who": "董其昌",
    "creator": "acking",
    "creator_uid": 9121,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619420342",
    "length": 10
  },
  {
    "id": 7323,
    "uuid": "e3ec7a6b-9fda-4a1f-b092-010a3033baca",
    "hitokoto": "在可疑的月亮里住着梦幻，不可企及者，失去了的时间，可能之物或不可能之物，两者是同一件事。",
    "type": "i",
    "from": "月亮",
    "from_who": "博尔赫斯",
    "creator": "fiammanda",
    "creator_uid": 9194,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620193993",
    "length": 44
  },
  {
    "id": 7331,
    "uuid": "a4cc1779-0903-48ee-8d41-4742ec16ed4f",
    "hitokoto": "只身千里客，孤枕一灯秋。",
    "type": "i",
    "from": "陆游",
    "from_who": "陆游",
    "creator": "主不在乎",
    "creator_uid": 9074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622290272",
    "length": 12
  },
  {
    "id": 7332,
    "uuid": "84070447-4997-46c8-8194-061d3440adb2",
    "hitokoto": "为君沉醉又何妨，只怕酒醒时候断人肠。",
    "type": "i",
    "from": "虞美人",
    "from_who": "秦观",
    "creator": "主不在乎",
    "creator_uid": 9074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622290322",
    "length": 18
  },
  {
    "id": 7396,
    "uuid": "8bd33878-7ed2-46df-9d18-46d61b1b5037",
    "hitokoto": "举世皆浊我独清，众人皆醉我独醒。",
    "type": "i",
    "from": "楚辞·渔父",
    "from_who": "屈原",
    "creator": "蕤甦",
    "creator_uid": 8897,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617536977",
    "length": 16
  },
  {
    "id": 7450,
    "uuid": "5213611b-f34c-434d-9c3b-20dc11ceae76",
    "hitokoto": "春赏百花秋望月，夏沐凉风冬听雪。",
    "type": "i",
    "from": "《无门关》第十九则",
    "from_who": "黄龙慧开禅师",
    "creator": "墨客熊",
    "creator_uid": 4413,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619752759",
    "length": 16
  },
  {
    "id": 7451,
    "uuid": "37a0eeed-8852-4be2-af43-dda8da1b9edf",
    "hitokoto": "人生天地间，忽如远行客。",
    "type": "i",
    "from": "古诗十九首",
    "from_who": null,
    "creator": "frankwuzp",
    "creator_uid": 9845,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626963799",
    "length": 12
  },
  {
    "id": 7457,
    "uuid": "c3d7a738-7ac9-43ec-8a4d-70005f724aed",
    "hitokoto": "西北有高楼，上与浮云齐。",
    "type": "i",
    "from": "古诗十九首",
    "from_who": null,
    "creator": "frankwuzp",
    "creator_uid": 9845,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626963882",
    "length": 12
  },
  {
    "id": 7477,
    "uuid": "49de7cf4-0c6b-4e8d-97e1-7007b296cdd3",
    "hitokoto": "山有榛，隰有苓。云谁之思？西方美人。",
    "type": "i",
    "from": "邶风·简兮",
    "from_who": "佚名",
    "creator": "奥修内平",
    "creator_uid": 10008,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628232491",
    "length": 18
  }
]